import React, { useState } from 'react'
import { IconContext } from 'react-icons'
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi'
import { BiChevronLeft, BiChevronRight, BiHelpCircle } from 'react-icons/bi'
import { IoInformationCircleOutline } from 'react-icons/io5'
import { BsArrowRepeat } from 'react-icons/bs'
import { FaRegEnvelope, FaPhoneAlt } from 'react-icons/fa'
//import { RiCustomerService2Line } from 'react-icons/ri'
import { MdOutlinePayments } from 'react-icons/md'
import cls from './index.module.scss'

const Payments = ({ active }) => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 7.03125V8.59375"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 16.4062V17.9688"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1562 16.4062H13.6719C14.1899 16.4062 14.6867 16.2005 15.0529 15.8342C15.4192 15.4679 15.625 14.9711 15.625 14.4531C15.625 13.9351 15.4192 13.4383 15.0529 13.0721C14.6867 12.7058 14.1899 12.5 13.6719 12.5H11.3281C10.8101 12.5 10.3133 12.2942 9.94706 11.9279C9.58078 11.5617 9.375 11.0649 9.375 10.5469C9.375 10.0289 9.58078 9.53209 9.94706 9.16581C10.3133 8.79953 10.8101 8.59375 11.3281 8.59375H14.8438"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const Lending = ({ active }) => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.125 5.03125H2.875C2.47805 5.03125 2.15625 5.35305 2.15625 5.75V17.25C2.15625 17.647 2.47805 17.9688 2.875 17.9688H20.125C20.522 17.9688 20.8438 17.647 20.8438 17.25V5.75C20.8438 5.35305 20.522 5.03125 20.125 5.03125Z"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0933 15.0938H17.9683"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.15576 8.70154H20.8433"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const Lending2 = ({ color }) => {
  const mColor = color ? color : '#273869'
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.4318 22.6136C30.8864 22.0682 30.3409 21.7954 29.6591 21.5227C28.0227 21.1136 26.5227 21.3864 25.2955 22.4773C24.3409 23.2954 23.5227 24.25 22.5682 25.2045C22.4318 25.3409 22.4318 25.3409 22.2955 25.3409C21.8864 25.3409 21.6136 25.3409 21.0682 25.3409C21.6136 24.5227 21.8864 23.7045 21.8864 22.75C21.8864 22.0682 21.6136 21.6591 20.7955 21.6591C19.9773 21.6591 19.0227 21.6591 18.2045 21.6591C17.5227 21.6591 16.9773 21.5227 16.4318 21.3864C15.75 21.1136 15.0682 20.8409 14.3864 20.4318C12.4773 19.4773 10.5682 19.3409 8.65909 19.8864C7.29546 20.1591 6.34091 20.9773 6.06818 22.4773C6.06818 22.6136 5.93182 22.6136 5.79546 22.6136C4.97727 22.6136 4.02273 22.6136 3.20455 22.6136C2.52273 22.6136 2.25 23.0227 2.25 23.5682C2.25 25.8864 2.25 28.2045 2.25 30.6591C2.25 31.3409 2.65909 31.6136 3.20455 31.6136C9.47727 31.6136 15.75 31.6136 22.0227 31.6136C23.1136 31.6136 24.0682 31.2045 24.75 30.5227C27.0682 28.3409 29.25 26.0227 31.4318 23.8409C31.8409 23.5682 31.8409 23.0227 31.4318 22.6136ZM5.79546 29.8409C5.25 29.8409 4.84091 29.8409 4.29545 29.8409C4.15909 29.8409 4.02273 29.8409 4.02273 29.5682C4.02273 27.9318 4.02273 26.2954 4.02273 24.6591C4.02273 24.5227 4.02273 24.3864 4.29545 24.3864C4.84091 24.3864 5.25 24.3864 5.79546 24.3864C6.06818 24.3864 6.06818 24.5227 6.06818 24.6591C6.06818 25.4773 6.06818 26.2954 6.06818 27.1136C6.06818 27.9318 6.06818 28.75 6.06818 29.4318C6.20455 29.8409 6.06818 29.9773 5.79546 29.8409ZM29.1136 23.7045C27.3409 25.4773 25.4318 27.3864 23.6591 29.1591C23.1136 29.7045 22.5682 29.8409 21.8864 29.8409C17.3864 29.8409 12.8864 29.8409 8.38636 29.8409C8.11364 29.8409 7.97727 29.7045 7.97727 29.4318C7.97727 27.25 7.97727 25.2045 7.97727 23.0227C7.97727 22.2045 8.25 21.9318 9.06818 21.6591C10.7045 21.25 12.3409 21.3864 13.9773 22.2045C15.0682 22.75 16.1591 23.2954 17.25 23.4318C17.6591 23.4318 17.9318 23.5682 18.3409 23.5682C18.8864 23.5682 19.4318 23.5682 19.9773 23.5682C19.7045 24.3864 18.8864 25.2045 17.9318 25.3409C17.6591 25.3409 17.3864 25.3409 17.1136 25.3409C15.75 25.3409 14.5227 25.3409 13.1591 25.3409C13.0227 25.3409 12.75 25.3409 12.6136 25.3409C12.2045 25.4773 11.9318 25.8864 11.9318 26.2954C11.9318 26.7045 12.3409 27.1136 12.75 27.1136C13.1591 27.1136 13.5682 27.1136 13.8409 27.1136C16.7045 27.1136 19.5682 27.1136 22.5682 27.1136C22.9773 27.1136 23.3864 26.9773 23.6591 26.7045C24.6136 25.75 25.5682 24.7954 26.5227 23.8409C27.3409 23.0227 28.4318 22.8864 29.3864 23.2954C29.3864 23.5682 29.25 23.5682 29.1136 23.7045Z"
        fill={mColor}
      />
      <path
        d="M19.9773 8.97723C19.4318 8.84087 19.0227 8.56814 18.4773 8.29542C18.2046 8.15905 18.0682 8.02269 18.2046 7.74996C18.2046 7.47723 18.3409 7.20451 18.75 7.20451C19.1591 7.06814 19.4318 7.20451 19.8409 7.34087C19.9773 7.47723 20.25 7.6136 20.5227 7.6136C20.9318 7.6136 21.2046 7.34087 21.3409 7.06814C21.4773 6.65905 21.3409 6.24996 21.0682 5.97723C20.7955 5.70451 20.5227 5.56814 20.25 5.56814C20.1136 5.56814 19.9773 5.43178 19.9773 5.29542C19.9773 4.74996 19.5682 4.47723 19.0227 4.47723C18.4773 4.47723 18.0682 4.88632 18.0682 5.29542C18.0682 5.56814 17.9318 5.56814 17.7955 5.70451C16.8409 6.1136 16.2955 7.20451 16.4318 8.29542C16.5682 8.97723 16.8409 9.52269 17.5227 9.93178C18.0682 10.3409 18.75 10.6136 19.4318 10.8863C19.9773 11.1591 20.25 11.7045 19.8409 12.25C19.7046 12.3863 19.2955 12.5227 18.8864 12.5227C18.3409 12.5227 17.9318 12.5227 17.3864 12.1136C16.9773 11.8409 16.4318 11.9772 16.1591 12.3863C15.8864 12.7954 16.0227 13.3409 16.4318 13.6136C16.8409 13.8863 17.25 14.1591 17.6591 14.1591C17.7955 14.1591 17.9318 14.2954 17.9318 14.4318C17.9318 14.9772 18.3409 15.3863 18.8864 15.25C19.4318 15.25 19.8409 14.8409 19.8409 14.2954C19.8409 14.1591 19.8409 14.0227 20.1136 13.8863C21.2046 13.3409 21.8864 12.25 21.8864 11.1591C21.75 10.3409 21.2046 9.38632 19.9773 8.97723Z"
        fill={mColor}
      />
      <path
        d="M19.0228 0.25C13.7046 0.25 9.47729 4.61364 9.47729 9.93182C9.47729 15.25 13.7046 19.6136 19.0228 19.6136C24.3409 19.6136 28.5682 15.25 28.5682 9.93182C28.5682 4.61364 24.3409 0.25 19.0228 0.25ZM19.0228 17.7045C14.7955 17.7045 11.25 14.1591 11.3864 9.93182C11.3864 5.56818 14.9318 2.15909 19.1591 2.15909C23.3864 2.15909 26.9318 5.70455 26.9318 9.93182C26.7955 14.2955 23.25 17.7045 19.0228 17.7045Z"
        fill={mColor}
      />
    </svg>
  )
}

const Accounts = ({ active }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 11.6666C12.7614 11.6666 15 9.42805 15 6.66663C15 3.9052 12.7614 1.66663 10 1.66663C7.23858 1.66663 5 3.9052 5 6.66663C5 9.42805 7.23858 11.6666 10 11.6666Z"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.4209 18.5409C3.1893 17.2109 4.29419 16.1065 5.62456 15.3386C6.95493 14.5708 8.46393 14.1666 9.99997 14.1666C11.536 14.1666 13.045 14.5709 14.3754 15.3387C15.7057 16.1066 16.8106 17.211 17.579 18.5411"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const Insights = ({ active }) => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.37524 19.5312H15.6252"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1565 22.6562H14.844"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.81207 16.4064C6.50047 15.4224 5.53168 14.0508 5.04292 12.4857C4.55416 10.9206 4.57021 9.2414 5.08879 7.68593C5.60737 6.13047 6.60219 4.77759 7.93236 3.81891C9.26253 2.86024 10.8606 2.34436 12.5002 2.34436C14.1399 2.34436 15.7379 2.86023 17.0681 3.8189C18.3983 4.77757 19.3931 6.13045 19.9117 7.68592C20.4303 9.24138 20.4463 10.9206 19.9576 12.4857C19.4688 14.0508 18.5 15.4224 17.1884 16.4063"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const LockIcon = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill="#385095" />
      <path
        d="M18.9995 11.5H8.99951C8.72337 11.5 8.49951 11.7239 8.49951 12V19C8.49951 19.2761 8.72337 19.5 8.99951 19.5H18.9995C19.2757 19.5 19.4995 19.2761 19.4995 19V12C19.4995 11.7239 19.2757 11.5 18.9995 11.5Z"
        stroke="#EFEFEF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9995 11.5H8.99951C8.72337 11.5 8.49951 11.7239 8.49951 12V19C8.49951 19.2761 8.72337 19.5 8.99951 19.5H18.9995C19.2757 19.5 19.4995 19.2761 19.4995 19V12C19.4995 11.7239 19.2757 11.5 18.9995 11.5Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7495 11.5V9.25C11.7495 8.65326 11.9866 8.08097 12.4085 7.65901C12.8305 7.23705 13.4028 7 13.9995 7C14.5962 7 15.1685 7.23705 15.5905 7.65901C16.0125 8.08097 16.2495 8.65326 16.2495 9.25V11.5"
        stroke="#EFEFEF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7495 11.5V9.25C11.7495 8.65326 11.9866 8.08097 12.4085 7.65901C12.8305 7.23705 13.4028 7 13.9995 7C14.5962 7 15.1685 7.23705 15.5905 7.65901C16.0125 8.08097 16.2495 8.65326 16.2495 9.25V11.5"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const PendingIcon = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill="#385095" />
      <path
        d="M14 14L10.2 11.15C10.1379 11.1034 10.0875 11.043 10.0528 10.9736C10.0181 10.9042 10 10.8276 10 10.75V8.5C10 8.36739 10.0527 8.24021 10.1464 8.14645C10.2402 8.05268 10.3674 8 10.5 8H17.5C17.6326 8 17.7598 8.05268 17.8536 8.14645C17.9473 8.24021 18 8.36739 18 8.5V10.7276C18 10.8049 17.9821 10.8811 17.9476 10.9503C17.9132 11.0195 17.8632 11.0798 17.8015 11.1264L14 14Z"
        stroke="#EFEFEF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14L10.2 11.15C10.1379 11.1034 10.0875 11.043 10.0528 10.9736C10.0181 10.9042 10 10.8276 10 10.75V8.5C10 8.36739 10.0527 8.24021 10.1464 8.14645C10.2402 8.05268 10.3674 8 10.5 8H17.5C17.6326 8 17.7598 8.05268 17.8536 8.14645C17.9473 8.24021 18 8.36739 18 8.5V10.7276C18 10.8049 17.9821 10.8811 17.9476 10.9503C17.9132 11.0195 17.8632 11.0798 17.8015 11.1264L14 14Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14L10.2 16.85C10.1379 16.8966 10.0875 16.957 10.0528 17.0264C10.0181 17.0958 10 17.1724 10 17.25V19.5C10 19.6326 10.0527 19.7598 10.1464 19.8536C10.2402 19.9473 10.3674 20 10.5 20H17.5C17.6326 20 17.7598 19.9473 17.8536 19.8536C17.9473 19.7598 18 19.6326 18 19.5V17.2724C18 17.1951 17.9821 17.1189 17.9476 17.0497C17.9132 16.9805 17.8632 16.9202 17.8015 16.8736L14 14Z"
        stroke="#EFEFEF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14L10.2 16.85C10.1379 16.8966 10.0875 16.957 10.0528 17.0264C10.0181 17.0958 10 17.1724 10 17.25V19.5C10 19.6326 10.0527 19.7598 10.1464 19.8536C10.2402 19.9473 10.3674 20 10.5 20H17.5C17.6326 20 17.7598 19.9473 17.8536 19.8536C17.9473 19.7598 18 19.6326 18 19.5V17.2724C18 17.1951 17.9821 17.1189 17.9476 17.0497C17.9132 16.9805 17.8632 16.9202 17.8015 16.8736L14 14Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6663 11.4998H17.3077"
        stroke="#EFEFEF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6663 11.4998H17.3077"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 16.4997V14"
        stroke="#EFEFEF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14 16.4997V14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const PendingIconLg = () => {
  const color = '#444'
  return (
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill={color} />
      <path
        d="M14 14L10.2 11.15C10.1379 11.1034 10.0875 11.043 10.0528 10.9736C10.0181 10.9042 10 10.8276 10 10.75V8.5C10 8.36739 10.0527 8.24021 10.1464 8.14645C10.2402 8.05268 10.3674 8 10.5 8H17.5C17.6326 8 17.7598 8.05268 17.8536 8.14645C17.9473 8.24021 18 8.36739 18 8.5V10.7276C18 10.8049 17.9821 10.8811 17.9476 10.9503C17.9132 11.0195 17.8632 11.0798 17.8015 11.1264L14 14Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14L10.2 11.15C10.1379 11.1034 10.0875 11.043 10.0528 10.9736C10.0181 10.9042 10 10.8276 10 10.75V8.5C10 8.36739 10.0527 8.24021 10.1464 8.14645C10.2402 8.05268 10.3674 8 10.5 8H17.5C17.6326 8 17.7598 8.05268 17.8536 8.14645C17.9473 8.24021 18 8.36739 18 8.5V10.7276C18 10.8049 17.9821 10.8811 17.9476 10.9503C17.9132 11.0195 17.8632 11.0798 17.8015 11.1264L14 14Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14L10.2 16.85C10.1379 16.8966 10.0875 16.957 10.0528 17.0264C10.0181 17.0958 10 17.1724 10 17.25V19.5C10 19.6326 10.0527 19.7598 10.1464 19.8536C10.2402 19.9473 10.3674 20 10.5 20H17.5C17.6326 20 17.7598 19.9473 17.8536 19.8536C17.9473 19.7598 18 19.6326 18 19.5V17.2724C18 17.1951 17.9821 17.1189 17.9476 17.0497C17.9132 16.9805 17.8632 16.9202 17.8015 16.8736L14 14Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14L10.2 16.85C10.1379 16.8966 10.0875 16.957 10.0528 17.0264C10.0181 17.0958 10 17.1724 10 17.25V19.5C10 19.6326 10.0527 19.7598 10.1464 19.8536C10.2402 19.9473 10.3674 20 10.5 20H17.5C17.6326 20 17.7598 19.9473 17.8536 19.8536C17.9473 19.7598 18 19.6326 18 19.5V17.2724C18 17.1951 17.9821 17.1189 17.9476 17.0497C17.9132 16.9805 17.8632 16.9202 17.8015 16.8736L14 14Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6663 11.4998H17.3077"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6663 11.4998H17.3077"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14 16.4997V14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 16.4997V14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const Support = ({ active }) => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.06112 12.6453C2.25742 11.2905 1.97596 9.68885 2.26958 8.14117C2.56321 6.59349 3.41173 5.20623 4.6558 4.2399C5.89988 3.27356 7.45393 2.79462 9.02614 2.893C10.5984 2.99139 12.0806 3.66033 13.1945 4.77423C14.3084 5.88812 14.9773 7.37034 15.0757 8.94255C15.1741 10.5148 14.6952 12.0688 13.7288 13.3129C12.7625 14.557 11.3753 15.4055 9.82757 15.6991C8.27989 15.9928 6.67826 15.7113 5.32341 14.9076L5.32343 14.9075L3.08924 15.5459C2.99681 15.5723 2.89899 15.5735 2.80593 15.5494C2.71287 15.5253 2.62795 15.4767 2.55998 15.4087C2.492 15.3408 2.44344 15.2558 2.41932 15.1628C2.39521 15.0697 2.39642 14.9719 2.42283 14.8795L3.06117 12.6453L3.06112 12.6453Z"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.271 15.8029C8.58899 16.7056 9.10324 17.5266 9.7767 18.2067C10.4502 18.8868 11.2661 19.4091 12.1656 19.7359C13.0652 20.0628 14.0261 20.186 14.9791 20.0969C15.932 20.0077 16.8533 19.7083 17.6767 19.2202L17.6767 19.2201L19.9108 19.8584C20.0033 19.8849 20.1011 19.8861 20.1942 19.862C20.2872 19.8378 20.3721 19.7893 20.4401 19.7213C20.5081 19.6533 20.5566 19.5684 20.5808 19.4753C20.6049 19.3823 20.6037 19.2845 20.5773 19.192L19.9389 16.9579L19.939 16.9579C20.5061 16.0014 20.8172 14.9148 20.8422 13.8031C20.8672 12.6913 20.6052 11.5919 20.0815 10.6108C19.5579 9.62982 18.7902 8.8003 17.8527 8.20233C16.9151 7.60437 15.8392 7.25813 14.7289 7.19702"
        stroke={active ? '#385095' : '#606D7B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const MoneyIcon127x170 = () => {
  return (
    <svg width="127" height="170" viewBox="0 0 127 170" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_66:17205)">
        <path
          d="M2 8C2 3.58173 5.58172 0 10 0H344C348.418 0 352 3.58172 352 8V158C352 162.418 348.418 166 344 166H10C5.58172 166 2 162.418 2 158V8Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M2 8C2 3.58172 5.58172 0 10 0H81V132H10C5.58172 132 2 128.418 2 124V8Z"
          fill="#E6F3FC"
        />
        <path d="M2 8C2 3.58173 5.58172 0 10 0H127L81 166H10C5.58172 166 2 162.418 2 158V8Z" fill="#4E7BC7" />
        <path
          d="M50.2428 145.49V127"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.2428 145.49V127"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41 134.245L50.245 125L59.49 134.245"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41 134.245L50.245 125L59.49 134.245"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M88.2428 34.49V16"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M88.2428 34.49V16"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M79 25.245L88.245 16L97.49 25.245"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M79 25.245L88.245 16L97.49 25.245"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="11.535"
          cy="112.535"
          r="13.5506"
          transform="rotate(-30 11.535 112.535)"
          stroke="#F6F6F6"
          strokeWidth="1.5"
        />
        <circle
          cx="11.535"
          cy="112.535"
          r="13.5506"
          transform="rotate(-30 11.535 112.535)"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
        />
        <path
          d="M16.5809 112.404C16.8451 112.861 16.9648 113.356 16.9401 113.887C16.9254 114.413 16.7659 114.93 16.4619 115.437C16.1678 115.938 15.7494 116.385 15.2069 116.778L16.1804 118.464C16.2551 118.593 16.2706 118.724 16.2271 118.855C16.1992 118.991 16.1206 119.096 15.9912 119.17C15.8619 119.245 15.7266 119.263 15.5854 119.225C15.4599 119.192 15.3598 119.11 15.2851 118.981L14.3203 117.31C13.6706 117.632 13.0281 117.817 12.3929 117.866C11.7577 117.914 11.0742 117.844 10.3424 117.657C10.1656 117.626 10.037 117.541 9.95663 117.402C9.88771 117.283 9.8693 117.147 9.90139 116.996C9.94344 116.839 10.0241 116.726 10.1435 116.657C10.2629 116.588 10.401 116.575 10.5579 116.617C11.6908 116.971 12.7755 116.909 13.812 116.429L11.3998 112.251C10.2981 112.503 9.37513 112.558 8.63078 112.418C7.88643 112.277 7.2759 111.794 6.79921 110.968C6.37994 110.242 6.29322 109.483 6.53902 108.691C6.77909 107.889 7.31385 107.196 8.1433 106.611L7.47995 105.462C7.40528 105.333 7.38477 105.205 7.4184 105.08C7.45624 104.939 7.53982 104.831 7.66914 104.756C7.79847 104.681 7.92876 104.666 8.06003 104.709C8.19551 104.737 8.30058 104.816 8.37524 104.945L9.02998 106.079C9.58593 105.825 10.1501 105.665 10.7226 105.599C11.2951 105.534 11.8153 105.585 12.2834 105.753C12.5302 105.836 12.6881 105.937 12.7571 106.056C12.8202 106.166 12.8308 106.299 12.7888 106.456C12.741 106.603 12.6574 106.711 12.538 106.78C12.4385 106.837 12.3339 106.851 12.224 106.822C11.8344 106.675 11.401 106.614 10.9238 106.637C10.4466 106.661 9.98766 106.773 9.54688 106.975L11.8902 111.033C12.616 110.866 13.249 110.779 13.7889 110.773C14.3331 110.75 14.8444 110.866 15.3228 111.12C15.8054 111.359 16.2248 111.787 16.5809 112.404ZM7.70712 110.404C7.99428 110.902 8.39313 111.202 8.90365 111.305C9.42412 111.403 10.0638 111.385 10.8226 111.252L8.65159 107.491C8.09493 107.906 7.72943 108.375 7.5551 108.9C7.37502 109.416 7.42569 109.917 7.70712 110.404ZM14.6987 115.898C15.2396 115.479 15.6022 115.005 15.7865 114.474C15.9651 113.933 15.9165 113.424 15.6408 112.946C15.3322 112.435 14.9198 112.122 14.4035 112.009C13.8815 111.886 13.2332 111.889 12.4588 112.018L14.6987 115.898Z"
          fill="#F6F6F6"
        />
        <path
          d="M16.5809 112.404C16.8451 112.861 16.9648 113.356 16.9401 113.887C16.9254 114.413 16.7659 114.93 16.4619 115.437C16.1678 115.938 15.7494 116.385 15.2069 116.778L16.1804 118.464C16.2551 118.593 16.2706 118.724 16.2271 118.855C16.1992 118.991 16.1206 119.096 15.9912 119.17C15.8619 119.245 15.7266 119.263 15.5854 119.225C15.4599 119.192 15.3598 119.11 15.2851 118.981L14.3203 117.31C13.6706 117.632 13.0281 117.817 12.3929 117.866C11.7577 117.914 11.0742 117.844 10.3424 117.657C10.1656 117.626 10.037 117.541 9.95663 117.402C9.88771 117.283 9.8693 117.147 9.90139 116.996C9.94344 116.839 10.0241 116.726 10.1435 116.657C10.2629 116.588 10.401 116.575 10.5579 116.617C11.6908 116.971 12.7755 116.909 13.812 116.429L11.3998 112.251C10.2981 112.503 9.37513 112.558 8.63078 112.418C7.88643 112.277 7.2759 111.794 6.79921 110.968C6.37994 110.242 6.29322 109.483 6.53902 108.691C6.77909 107.889 7.31385 107.196 8.1433 106.611L7.47995 105.462C7.40528 105.333 7.38477 105.205 7.4184 105.08C7.45624 104.939 7.53982 104.831 7.66914 104.756C7.79847 104.681 7.92876 104.666 8.06003 104.709C8.19551 104.737 8.30058 104.816 8.37524 104.945L9.02998 106.079C9.58593 105.825 10.1501 105.665 10.7226 105.599C11.2951 105.534 11.8153 105.585 12.2834 105.753C12.5302 105.836 12.6881 105.937 12.7571 106.056C12.8202 106.166 12.8308 106.299 12.7888 106.456C12.741 106.603 12.6574 106.711 12.538 106.78C12.4385 106.837 12.3339 106.851 12.224 106.822C11.8344 106.675 11.401 106.614 10.9238 106.637C10.4466 106.661 9.98766 106.773 9.54688 106.975L11.8902 111.033C12.616 110.866 13.249 110.779 13.7889 110.773C14.3331 110.75 14.8444 110.866 15.3228 111.12C15.8054 111.359 16.2248 111.787 16.5809 112.404ZM7.70712 110.404C7.99428 110.902 8.39313 111.202 8.90365 111.305C9.42412 111.403 10.0638 111.385 10.8226 111.252L8.65159 107.491C8.09493 107.906 7.72943 108.375 7.5551 108.9C7.37502 109.416 7.42569 109.917 7.70712 110.404ZM14.6987 115.898C15.2396 115.479 15.6022 115.005 15.7865 114.474C15.9651 113.933 15.9165 113.424 15.6408 112.946C15.3322 112.435 14.9198 112.122 14.4035 112.009C13.8815 111.886 13.2332 111.889 12.4588 112.018L14.6987 115.898Z"
          fill="white"
          fillOpacity="0.25"
        />
        <path
          d="M90.3298 87.5315C93.4175 92.2247 91.6168 98.301 86.1592 101.066C80.7016 103.831 73.8047 102.162 70.717 97.4684C67.6293 92.7752 69.4301 86.699 74.8876 83.9339C80.3452 81.1688 87.2421 82.8384 90.3298 87.5315Z"
          stroke="#F6F6F6"
          strokeWidth="1.5"
        />
        <path
          d="M90.3298 87.5315C93.4175 92.2247 91.6168 98.301 86.1592 101.066C80.7016 103.831 73.8047 102.162 70.717 97.4684C67.6293 92.7752 69.4301 86.699 74.8876 83.9339C80.3452 81.1688 87.2421 82.8384 90.3298 87.5315Z"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
        />
        <path
          d="M82.3627 92.7538C82.1652 92.4536 81.8855 92.258 81.5238 92.1672C81.1655 92.0746 80.665 92.0802 80.0224 92.1838C79.1407 92.3478 78.4174 92.3465 77.8526 92.1802C77.2892 92.0088 76.8346 91.6604 76.489 91.135C76.1369 90.5998 76.0136 90.077 76.1192 89.5667C76.2283 89.0545 76.5523 88.6184 77.0913 88.2583L76.386 87.1863L77.1648 86.7917L77.8733 87.8686C78.5081 87.6471 79.1142 87.6468 79.6916 87.8677C80.2725 88.0868 80.783 88.5308 81.2231 89.1998L80.2614 89.6871C79.9587 89.2269 79.6015 88.9206 79.1898 88.768C78.7781 88.6154 78.3737 88.6398 77.9765 88.8411C77.5618 89.0511 77.3113 89.313 77.2248 89.6265C77.1363 89.9368 77.2101 90.2714 77.4463 90.6304C77.6653 90.9632 77.9552 91.1709 78.3162 91.2535C78.6785 91.331 79.1781 91.3172 79.8151 91.212C80.4534 91.1018 80.9851 91.0695 81.4101 91.1153C81.8364 91.156 82.2041 91.2699 82.5131 91.4571C82.8256 91.6425 83.0956 91.9082 83.3232 92.2541C83.686 92.8056 83.8003 93.3395 83.666 93.8556C83.5352 94.3701 83.1714 94.8198 82.5745 95.2049L83.1896 96.1399L82.4161 96.5318L81.801 95.5968C81.1163 95.8697 80.4659 95.9121 79.8496 95.724C79.2347 95.5308 78.7147 95.1111 78.2896 94.465L79.2565 93.9751C79.555 94.4287 79.9119 94.7134 80.3273 94.8293C80.7427 94.9452 81.1838 94.8848 81.6508 94.6483C82.1072 94.417 82.3985 94.1323 82.5246 93.7943C82.6507 93.4564 82.5967 93.1095 82.3627 92.7538Z"
          fill="#F6F6F6"
        />
        <path
          d="M82.3627 92.7538C82.1652 92.4536 81.8855 92.258 81.5238 92.1672C81.1655 92.0746 80.665 92.0802 80.0224 92.1838C79.1407 92.3478 78.4174 92.3465 77.8526 92.1802C77.2892 92.0088 76.8346 91.6604 76.489 91.135C76.1369 90.5998 76.0136 90.077 76.1192 89.5667C76.2283 89.0545 76.5523 88.6184 77.0913 88.2583L76.386 87.1863L77.1648 86.7917L77.8733 87.8686C78.5081 87.6471 79.1142 87.6468 79.6916 87.8677C80.2725 88.0868 80.783 88.5308 81.2231 89.1998L80.2614 89.6871C79.9587 89.2269 79.6015 88.9206 79.1898 88.768C78.7781 88.6154 78.3737 88.6398 77.9765 88.8411C77.5618 89.0511 77.3113 89.313 77.2248 89.6265C77.1363 89.9368 77.2101 90.2714 77.4463 90.6304C77.6653 90.9632 77.9552 91.1709 78.3162 91.2535C78.6785 91.331 79.1781 91.3172 79.8151 91.212C80.4534 91.1018 80.9851 91.0695 81.4101 91.1153C81.8364 91.156 82.2041 91.2699 82.5131 91.4571C82.8256 91.6425 83.0956 91.9082 83.3232 92.2541C83.686 92.8056 83.8003 93.3395 83.666 93.8556C83.5352 94.3701 83.1714 94.8198 82.5745 95.2049L83.1896 96.1399L82.4161 96.5318L81.801 95.5968C81.1163 95.8697 80.4659 95.9121 79.8496 95.724C79.2347 95.5308 78.7147 95.1111 78.2896 94.465L79.2565 93.9751C79.555 94.4287 79.9119 94.7134 80.3273 94.8293C80.7427 94.9452 81.1838 94.8848 81.6508 94.6483C82.1072 94.417 82.3985 94.1323 82.5246 93.7943C82.6507 93.4564 82.5967 93.1095 82.3627 92.7538Z"
          fill="white"
          fillOpacity="0.25"
        />
        <path
          d="M51.0246 45.7542L27.6025 70.5421C26.1652 72.0632 26.1652 74.5294 27.6025 76.0505L43.2172 92.5758C44.6545 94.0969 46.9848 94.0969 48.4221 92.5758L71.8442 67.7879C73.2815 66.2668 73.2815 63.8006 71.8442 62.2795L56.2295 45.7542C54.7922 44.2331 52.4619 44.2331 51.0246 45.7542Z"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.0246 45.7542L27.6025 70.5421C26.1652 72.0632 26.1652 74.5294 27.6025 76.0505L43.2172 92.5758C44.6545 94.0969 46.9848 94.0969 48.4221 92.5758L71.8442 67.7879C73.2815 66.2668 73.2815 63.8006 71.8442 62.2795L56.2295 45.7542C54.7922 44.2331 52.4619 44.2331 51.0246 45.7542Z"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.8049 81.5514L61.4221 51.2656"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.8049 81.5514L61.4221 51.2656"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="23.035"
          cy="26.035"
          r="8.79229"
          transform="rotate(-30 23.035 26.035)"
          stroke="#F6F6F6"
          strokeWidth="1.5"
        />
        <circle
          cx="23.035"
          cy="26.035"
          r="8.79229"
          transform="rotate(-30 23.035 26.035)"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
        />
        <path
          d="M26.2875 25.4622C26.5645 25.942 26.6304 26.4529 26.4851 26.9949C26.3362 27.5305 26.0188 27.999 25.5331 28.4004L25.9991 29.2076C26.074 29.3373 26.0922 29.4737 26.0539 29.6169C26.0155 29.7601 25.9282 29.871 25.7921 29.9496C25.6624 30.0245 25.5292 30.0408 25.3925 29.9987C25.2558 29.9566 25.1501 29.8707 25.0752 29.7411L24.626 28.963C24.2312 29.1477 23.8408 29.2651 23.4547 29.3151C23.0751 29.3613 22.6711 29.3353 22.2425 29.2369C22.039 29.1988 21.8942 29.1052 21.8081 28.9561C21.7407 28.8394 21.7262 28.7094 21.7645 28.5663C21.7992 28.4166 21.8781 28.3062 22.0013 28.2351C22.1115 28.1714 22.2261 28.1528 22.3451 28.1792C22.6778 28.2465 22.9849 28.2767 23.2662 28.2698C23.5503 28.2528 23.8313 28.1856 24.1094 28.0683L22.8123 25.8217C22.1076 26.0384 21.4986 26.0917 20.9855 25.9817C20.4752 25.8614 20.0665 25.5354 19.7596 25.0037C19.4639 24.4915 19.397 23.9639 19.5589 23.4209C19.7209 22.8778 20.0698 22.4041 20.6056 21.9996L20.3193 21.5036C20.2444 21.3739 20.2229 21.2394 20.2548 21.0999C20.2932 20.9568 20.3804 20.8459 20.5166 20.7673C20.6463 20.6924 20.7794 20.676 20.9161 20.7181C21.0593 20.7565 21.1683 20.8405 21.2432 20.9702L21.5408 21.4856C21.8717 21.3551 22.2006 21.2733 22.5273 21.2403C22.854 21.2072 23.1503 21.2263 23.4162 21.2976C23.6402 21.3412 23.7953 21.4375 23.8814 21.5866C23.9487 21.7033 23.9632 21.8333 23.9249 21.9765C23.893 22.1159 23.8155 22.2212 23.6923 22.2923C23.6015 22.3447 23.512 22.3618 23.4237 22.3436C23.2433 22.3008 23.0311 22.285 22.7869 22.2963C22.5492 22.3039 22.3116 22.3416 22.0742 22.4095L23.3208 24.5686C24.0368 24.3713 24.6281 24.3325 25.0948 24.452C25.5643 24.5614 25.9618 24.8981 26.2875 25.4622ZM20.661 24.4314C20.8108 24.6907 21.0167 24.8528 21.2789 24.9176C21.5438 24.9721 21.8715 24.9558 22.2621 24.8686L21.1278 22.9041C20.8401 23.1394 20.6541 23.3937 20.5699 23.6671C20.4922 23.9367 20.5225 24.1915 20.661 24.4314ZM25.0053 27.4862C25.2326 27.2512 25.3806 27.0059 25.4491 26.7502C25.5241 26.4908 25.4998 26.2541 25.3763 26.0401C25.2276 25.7975 25.0318 25.6382 24.7891 25.5622C24.5427 25.4797 24.2385 25.4694 23.8766 25.5314L25.0053 27.4862Z"
          fill="#F6F6F6"
        />
        <path
          d="M26.2875 25.4622C26.5645 25.942 26.6304 26.4529 26.4851 26.9949C26.3362 27.5305 26.0188 27.999 25.5331 28.4004L25.9991 29.2076C26.074 29.3373 26.0922 29.4737 26.0539 29.6169C26.0155 29.7601 25.9282 29.871 25.7921 29.9496C25.6624 30.0245 25.5292 30.0408 25.3925 29.9987C25.2558 29.9566 25.1501 29.8707 25.0752 29.7411L24.626 28.963C24.2312 29.1477 23.8408 29.2651 23.4547 29.3151C23.0751 29.3613 22.6711 29.3353 22.2425 29.2369C22.039 29.1988 21.8942 29.1052 21.8081 28.9561C21.7407 28.8394 21.7262 28.7094 21.7645 28.5663C21.7992 28.4166 21.8781 28.3062 22.0013 28.2351C22.1115 28.1714 22.2261 28.1528 22.3451 28.1792C22.6778 28.2465 22.9849 28.2767 23.2662 28.2698C23.5503 28.2528 23.8313 28.1856 24.1094 28.0683L22.8123 25.8217C22.1076 26.0384 21.4986 26.0917 20.9855 25.9817C20.4752 25.8614 20.0665 25.5354 19.7596 25.0037C19.4639 24.4915 19.397 23.9639 19.5589 23.4209C19.7209 22.8778 20.0698 22.4041 20.6056 21.9996L20.3193 21.5036C20.2444 21.3739 20.2229 21.2394 20.2548 21.0999C20.2932 20.9568 20.3804 20.8459 20.5166 20.7673C20.6463 20.6924 20.7794 20.676 20.9161 20.7181C21.0593 20.7565 21.1683 20.8405 21.2432 20.9702L21.5408 21.4856C21.8717 21.3551 22.2006 21.2733 22.5273 21.2403C22.854 21.2072 23.1503 21.2263 23.4162 21.2976C23.6402 21.3412 23.7953 21.4375 23.8814 21.5866C23.9487 21.7033 23.9632 21.8333 23.9249 21.9765C23.893 22.1159 23.8155 22.2212 23.6923 22.2923C23.6015 22.3447 23.512 22.3618 23.4237 22.3436C23.2433 22.3008 23.0311 22.285 22.7869 22.2963C22.5492 22.3039 22.3116 22.3416 22.0742 22.4095L23.3208 24.5686C24.0368 24.3713 24.6281 24.3325 25.0948 24.452C25.5643 24.5614 25.9618 24.8981 26.2875 25.4622ZM20.661 24.4314C20.8108 24.6907 21.0167 24.8528 21.2789 24.9176C21.5438 24.9721 21.8715 24.9558 22.2621 24.8686L21.1278 22.9041C20.8401 23.1394 20.6541 23.3937 20.5699 23.6671C20.4922 23.9367 20.5225 24.1915 20.661 24.4314ZM25.0053 27.4862C25.2326 27.2512 25.3806 27.0059 25.4491 26.7502C25.5241 26.4908 25.4998 26.2541 25.3763 26.0401C25.2276 25.7975 25.0318 25.6382 24.7891 25.5622C24.5427 25.4797 24.2385 25.4694 23.8766 25.5314L25.0053 27.4862Z"
          fill="white"
          fillOpacity="0.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_66:17205">
          <path
            d="M2 8C2 3.58173 5.58172 0 10 0H344C348.418 0 352 3.58172 352 8V158C352 162.418 348.418 166 344 166H10C5.58172 166 2 162.418 2 158V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const MoneyIcon80x107 = () => {
  return (
    <svg width="80" height="107" viewBox="0 0 80 107" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_66:17110)">
        <path
          d="M2 8C2 3.58172 5.58172 0 10 0H324C328.418 0 332 3.58172 332 8V95C332 99.4183 328.418 103 324 103H9.99999C5.58171 103 2 99.4183 2 95V8Z"
          fill="white"
        />
        <path
          d="M2 8C2 3.58172 5.58172 0 10 0H79.5602L51.0181 103H10C5.58172 103 2 99.4183 2 95V8Z"
          fill="#4E7BC7"
        />
        <circle
          cx="19.035"
          cy="13.0351"
          r="8.79229"
          transform="rotate(-30 19.035 13.0351)"
          stroke="#F6F6F6"
          strokeWidth="1.5"
        />
        <circle
          cx="19.035"
          cy="13.0351"
          r="8.79229"
          transform="rotate(-30 19.035 13.0351)"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
        />
        <path
          d="M22.2875 12.4622C22.5645 12.942 22.6304 13.4529 22.4851 13.9949C22.3362 14.5305 22.0188 14.999 21.5331 15.4004L21.9991 16.2076C22.074 16.3373 22.0922 16.4737 22.0539 16.6169C22.0155 16.7601 21.9282 16.871 21.7921 16.9496C21.6624 17.0245 21.5292 17.0408 21.3925 16.9987C21.2558 16.9566 21.1501 16.8707 21.0752 16.7411L20.626 15.963C20.2312 16.1477 19.8408 16.2651 19.4547 16.3151C19.0751 16.3613 18.6711 16.3353 18.2425 16.2369C18.039 16.1988 17.8942 16.1052 17.8081 15.9561C17.7407 15.8394 17.7262 15.7094 17.7645 15.5663C17.7992 15.4166 17.8781 15.3062 18.0013 15.2351C18.1115 15.1714 18.2261 15.1528 18.3451 15.1792C18.6778 15.2465 18.9849 15.2767 19.2662 15.2698C19.5503 15.2528 19.8313 15.1856 20.1094 15.0683L18.8123 12.8217C18.1076 13.0384 17.4986 13.0917 16.9855 12.9817C16.4752 12.8614 16.0665 12.5354 15.7596 12.0037C15.4639 11.4915 15.397 10.9639 15.5589 10.4209C15.7209 9.87783 16.0698 9.40407 16.6056 8.9996L16.3193 8.5036C16.2444 8.37392 16.2229 8.23937 16.2548 8.09994C16.2932 7.95676 16.3804 7.84587 16.5166 7.76726C16.6463 7.69239 16.7794 7.67601 16.9161 7.71812C17.0593 7.75648 17.1683 7.8405 17.2432 7.97017L17.5408 8.48562C17.8717 8.35507 18.2006 8.27328 18.5273 8.24025C18.854 8.20723 19.1503 8.22634 19.4162 8.29758C19.6402 8.34116 19.7953 8.43751 19.8814 8.58663C19.9487 8.70334 19.9632 8.83328 19.9249 8.97646C19.893 9.11589 19.8155 9.22117 19.6923 9.2923C19.6015 9.3447 19.512 9.36182 19.4237 9.34364C19.2433 9.3008 19.0311 9.28503 18.7869 9.29633C18.5492 9.30389 18.3116 9.34162 18.0742 9.40954L19.3208 11.5686C20.0368 11.3713 20.6281 11.3325 21.0948 11.452C21.5643 11.5614 21.9618 11.8981 22.2875 12.4622ZM16.661 11.4314C16.8108 11.6907 17.0167 11.8528 17.2789 11.9176C17.5438 11.9721 17.8715 11.9558 18.2621 11.8686L17.1278 9.90406C16.8401 10.1394 16.6541 10.3937 16.5699 10.6671C16.4922 10.9367 16.5225 11.1915 16.661 11.4314ZM21.0053 14.4862C21.2326 14.2512 21.3806 14.0059 21.4491 13.7502C21.5241 13.4908 21.4998 13.2541 21.3763 13.0401C21.2276 12.7975 21.0318 12.6382 20.7891 12.5622C20.5427 12.4797 20.2385 12.4694 19.8766 12.5314L21.0053 14.4862Z"
          fill="#F6F6F6"
        />
        <path
          d="M22.2875 12.4622C22.5645 12.942 22.6304 13.4529 22.4851 13.9949C22.3362 14.5305 22.0188 14.999 21.5331 15.4004L21.9991 16.2076C22.074 16.3373 22.0922 16.4737 22.0539 16.6169C22.0155 16.7601 21.9282 16.871 21.7921 16.9496C21.6624 17.0245 21.5292 17.0408 21.3925 16.9987C21.2558 16.9566 21.1501 16.8707 21.0752 16.7411L20.626 15.963C20.2312 16.1477 19.8408 16.2651 19.4547 16.3151C19.0751 16.3613 18.6711 16.3353 18.2425 16.2369C18.039 16.1988 17.8942 16.1052 17.8081 15.9561C17.7407 15.8394 17.7262 15.7094 17.7645 15.5663C17.7992 15.4166 17.8781 15.3062 18.0013 15.2351C18.1115 15.1714 18.2261 15.1528 18.3451 15.1792C18.6778 15.2465 18.9849 15.2767 19.2662 15.2698C19.5503 15.2528 19.8313 15.1856 20.1094 15.0683L18.8123 12.8217C18.1076 13.0384 17.4986 13.0917 16.9855 12.9817C16.4752 12.8614 16.0665 12.5354 15.7596 12.0037C15.4639 11.4915 15.397 10.9639 15.5589 10.4209C15.7209 9.87783 16.0698 9.40407 16.6056 8.9996L16.3193 8.5036C16.2444 8.37392 16.2229 8.23937 16.2548 8.09994C16.2932 7.95676 16.3804 7.84587 16.5166 7.76726C16.6463 7.69239 16.7794 7.67601 16.9161 7.71812C17.0593 7.75648 17.1683 7.8405 17.2432 7.97017L17.5408 8.48562C17.8717 8.35507 18.2006 8.27328 18.5273 8.24025C18.854 8.20723 19.1503 8.22634 19.4162 8.29758C19.6402 8.34116 19.7953 8.43751 19.8814 8.58663C19.9487 8.70334 19.9632 8.83328 19.9249 8.97646C19.893 9.11589 19.8155 9.22117 19.6923 9.2923C19.6015 9.3447 19.512 9.36182 19.4237 9.34364C19.2433 9.3008 19.0311 9.28503 18.7869 9.29633C18.5492 9.30389 18.3116 9.34162 18.0742 9.40954L19.3208 11.5686C20.0368 11.3713 20.6281 11.3325 21.0948 11.452C21.5643 11.5614 21.9618 11.8981 22.2875 12.4622ZM16.661 11.4314C16.8108 11.6907 17.0167 11.8528 17.2789 11.9176C17.5438 11.9721 17.8715 11.9558 18.2621 11.8686L17.1278 9.90406C16.8401 10.1394 16.6541 10.3937 16.5699 10.6671C16.4922 10.9367 16.5225 11.1915 16.661 11.4314ZM21.0053 14.4862C21.2326 14.2512 21.3806 14.0059 21.4491 13.7502C21.5241 13.4908 21.4998 13.2541 21.3763 13.0401C21.2276 12.7975 21.0318 12.6382 20.7891 12.5622C20.5427 12.4797 20.2385 12.4694 19.8766 12.5314L21.0053 14.4862Z"
          fill="white"
          fillOpacity="0.25"
        />
        <path
          d="M31.9338 90.274V78.8013"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.9338 90.274V78.8013"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1989 83.2967L31.9352 77.5603L37.6716 83.2967"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1989 83.2967L31.9352 77.5603L37.6716 83.2967"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.5121 21.4004V9.92773"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.5121 21.4004V9.92773"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.7771 15.6641L55.5135 9.92773L61.2498 15.6641"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.7771 15.6641L55.5135 9.92773L61.2498 15.6641"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="7.15549"
          cy="79.2882"
          r="13.5506"
          transform="rotate(-30 7.15549 79.2882)"
          stroke="#F6F6F6"
          strokeWidth="1.5"
        />
        <circle
          cx="7.15549"
          cy="79.2882"
          r="13.5506"
          transform="rotate(-30 7.15549 79.2882)"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
        />
        <path
          d="M12.2014 79.1565C12.4656 79.6141 12.5853 80.1087 12.5606 80.6402C12.5458 81.166 12.3864 81.6825 12.0824 82.1896C11.7882 82.691 11.3699 83.1381 10.8274 83.5309L11.8009 85.2171C11.8756 85.3464 11.8911 85.4767 11.8475 85.608C11.8196 85.7435 11.741 85.8485 11.6117 85.9232C11.4824 85.9979 11.3471 86.0163 11.2059 85.9784C11.0804 85.9448 10.9803 85.8633 10.9056 85.734L9.94074 84.0628C9.29106 84.3848 8.6486 84.57 8.01338 84.6185C7.37815 84.6669 6.69467 84.5973 5.96293 84.4096C5.78612 84.379 5.65752 84.2941 5.57711 84.1549C5.50819 84.0355 5.48978 83.9002 5.52188 83.749C5.56392 83.5921 5.64463 83.4792 5.764 83.4103C5.88337 83.3414 6.02152 83.3279 6.17843 83.37C7.31126 83.724 8.39594 83.6615 9.43246 83.1824L7.02026 79.0043C5.91861 79.2557 4.99561 79.3111 4.25126 79.1705C3.50691 79.03 2.89639 78.5468 2.41969 77.7212C2.00043 76.995 1.9137 76.236 2.15951 75.4441C2.39957 74.6424 2.93433 73.949 3.76379 73.364L3.10043 72.215C3.02577 72.0857 3.00525 71.9583 3.03889 71.8327C3.07673 71.6915 3.16031 71.5836 3.28963 71.5089C3.41895 71.4342 3.54925 71.4187 3.68052 71.4623C3.81599 71.4902 3.92106 71.5688 3.99573 71.6981L4.65047 72.8321C5.20641 72.5775 5.77062 72.4175 6.34308 72.3523C6.91555 72.2871 7.43581 72.3382 7.90388 72.5056C8.15073 72.5886 8.30862 72.6898 8.37754 72.8091C8.44071 72.9186 8.45128 73.0517 8.40923 73.2086C8.36145 73.3556 8.27787 73.4635 8.15849 73.5325C8.05902 73.5899 7.95436 73.6039 7.84452 73.5745C7.45491 73.428 7.02151 73.3666 6.54432 73.3901C6.06713 73.4136 5.60815 73.526 5.16737 73.7274L7.51065 77.7861C8.23653 77.619 8.86945 77.5322 9.4094 77.5255C9.95356 77.5031 10.4649 77.6191 10.9433 77.8734C11.4259 78.1121 11.8453 78.5398 12.2014 79.1565ZM3.3276 77.1572C3.61477 77.6546 4.01361 77.9549 4.52414 78.058C5.04461 78.1554 5.68425 78.1376 6.44305 78.0046L4.27207 74.2443C3.71541 74.6586 3.34991 75.1282 3.17558 75.6533C2.9955 76.1685 3.04618 76.6698 3.3276 77.1572ZM10.3191 82.6506C10.8601 82.2321 11.2227 81.7575 11.407 81.2267C11.5855 80.6859 11.537 80.1768 11.2613 79.6993C10.9527 79.1877 10.5403 78.8754 10.024 78.7623C9.50199 78.6392 8.85373 78.6421 8.07924 78.7709L10.3191 82.6506Z"
          fill="#F6F6F6"
        />
        <path
          d="M12.2014 79.1565C12.4656 79.6141 12.5853 80.1087 12.5606 80.6402C12.5458 81.166 12.3864 81.6825 12.0824 82.1896C11.7882 82.691 11.3699 83.1381 10.8274 83.5309L11.8009 85.2171C11.8756 85.3464 11.8911 85.4767 11.8475 85.608C11.8196 85.7435 11.741 85.8485 11.6117 85.9232C11.4824 85.9979 11.3471 86.0163 11.2059 85.9784C11.0804 85.9448 10.9803 85.8633 10.9056 85.734L9.94074 84.0628C9.29106 84.3848 8.6486 84.57 8.01338 84.6185C7.37815 84.6669 6.69467 84.5973 5.96293 84.4096C5.78612 84.379 5.65752 84.2941 5.57711 84.1549C5.50819 84.0355 5.48978 83.9002 5.52188 83.749C5.56392 83.5921 5.64463 83.4792 5.764 83.4103C5.88337 83.3414 6.02152 83.3279 6.17843 83.37C7.31126 83.724 8.39594 83.6615 9.43246 83.1824L7.02026 79.0043C5.91861 79.2557 4.99561 79.3111 4.25126 79.1705C3.50691 79.03 2.89639 78.5468 2.41969 77.7212C2.00043 76.995 1.9137 76.236 2.15951 75.4441C2.39957 74.6424 2.93433 73.949 3.76379 73.364L3.10043 72.215C3.02577 72.0857 3.00525 71.9583 3.03889 71.8327C3.07673 71.6915 3.16031 71.5836 3.28963 71.5089C3.41895 71.4342 3.54925 71.4187 3.68052 71.4623C3.81599 71.4902 3.92106 71.5688 3.99573 71.6981L4.65047 72.8321C5.20641 72.5775 5.77062 72.4175 6.34308 72.3523C6.91555 72.2871 7.43581 72.3382 7.90388 72.5056C8.15073 72.5886 8.30862 72.6898 8.37754 72.8091C8.44071 72.9186 8.45128 73.0517 8.40923 73.2086C8.36145 73.3556 8.27787 73.4635 8.15849 73.5325C8.05902 73.5899 7.95436 73.6039 7.84452 73.5745C7.45491 73.428 7.02151 73.3666 6.54432 73.3901C6.06713 73.4136 5.60815 73.526 5.16737 73.7274L7.51065 77.7861C8.23653 77.619 8.86945 77.5322 9.4094 77.5255C9.95356 77.5031 10.4649 77.6191 10.9433 77.8734C11.4259 78.1121 11.8453 78.5398 12.2014 79.1565ZM3.3276 77.1572C3.61477 77.6546 4.01361 77.9549 4.52414 78.058C5.04461 78.1554 5.68425 78.1376 6.44305 78.0046L4.27207 74.2443C3.71541 74.6586 3.34991 75.1282 3.17558 75.6533C2.9955 76.1685 3.04618 76.6698 3.3276 77.1572ZM10.3191 82.6506C10.8601 82.2321 11.2227 81.7575 11.407 81.2267C11.5855 80.6859 11.537 80.1768 11.2613 79.6993C10.9527 79.1877 10.5403 78.8754 10.024 78.7623C9.50199 78.6392 8.85373 78.6421 8.07924 78.7709L10.3191 82.6506Z"
          fill="white"
          fillOpacity="0.25"
        />
        <path
          d="M57.0321 60.7063C59.0933 63.8392 57.9017 67.9203 54.2222 69.7845C50.5427 71.6487 45.9194 70.5137 43.8583 67.3809C41.7971 64.248 42.9887 60.167 46.6682 58.3027C50.3477 56.4385 54.971 57.5735 57.0321 60.7063Z"
          stroke="#F6F6F6"
          strokeWidth="1.5"
        />
        <path
          d="M57.0321 60.7063C59.0933 63.8392 57.9017 67.9203 54.2222 69.7845C50.5427 71.6487 45.9194 70.5137 43.8583 67.3809C41.7971 64.248 42.9887 60.167 46.6682 58.3027C50.3477 56.4385 54.971 57.5735 57.0321 60.7063Z"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
        />
        <path
          d="M52.6653 65.1375C52.5172 64.9124 52.3074 64.7657 52.0361 64.6976C51.7674 64.6281 51.3921 64.6323 50.9101 64.7101C50.2488 64.833 49.7063 64.8321 49.2828 64.7073C48.8602 64.5787 48.5193 64.3174 48.26 63.9234C47.9959 63.522 47.9035 63.1299 47.9827 62.7472C48.0645 62.3631 48.3075 62.036 48.7118 61.7659L48.1828 60.9619L48.7669 60.666L49.2983 61.4736C49.7744 61.3075 50.2289 61.3072 50.662 61.4729C51.0977 61.6373 51.4805 61.9703 51.8106 62.472L51.0893 62.8375C50.8623 62.4924 50.5944 62.2626 50.2857 62.1482C49.9769 62.0338 49.6736 62.052 49.3756 62.203C49.0646 62.3605 48.8767 62.5569 48.8119 62.7921C48.7455 63.0248 48.8009 63.2757 48.978 63.545C49.1422 63.7946 49.3597 63.9504 49.6304 64.0123C49.9021 64.0704 50.2769 64.06 50.7546 63.9812C51.2334 63.8985 51.6321 63.8743 51.9509 63.9086C52.2706 63.9392 52.5464 64.0246 52.7781 64.165C53.0125 64.3041 53.215 64.5033 53.3857 64.7628C53.6578 65.1764 53.7435 65.5768 53.6428 65.9639C53.5447 66.3497 53.2719 66.687 52.8242 66.9759L53.2855 67.6771L52.7054 67.971L52.244 67.2698C51.7306 67.4745 51.2427 67.5063 50.7805 67.3651C50.3193 67.2203 49.9293 66.9055 49.6105 66.4209L50.3357 66.0535C50.5595 66.3937 50.8272 66.6072 51.1388 66.6941C51.4503 66.7811 51.7812 66.7358 52.1314 66.5584C52.4737 66.3849 52.6922 66.1714 52.7867 65.9179C52.8813 65.6644 52.8408 65.4043 52.6653 65.1375Z"
          fill="#F6F6F6"
        />
        <path
          d="M52.6653 65.1375C52.5172 64.9124 52.3074 64.7657 52.0361 64.6976C51.7674 64.6281 51.3921 64.6323 50.9101 64.7101C50.2488 64.833 49.7063 64.8321 49.2828 64.7073C48.8602 64.5787 48.5193 64.3174 48.26 63.9234C47.9959 63.522 47.9035 63.1299 47.9827 62.7472C48.0645 62.3631 48.3075 62.036 48.7118 61.7659L48.1828 60.9619L48.7669 60.666L49.2983 61.4736C49.7744 61.3075 50.2289 61.3072 50.662 61.4729C51.0977 61.6373 51.4805 61.9703 51.8106 62.472L51.0893 62.8375C50.8623 62.4924 50.5944 62.2626 50.2857 62.1482C49.9769 62.0338 49.6736 62.052 49.3756 62.203C49.0646 62.3605 48.8767 62.5569 48.8119 62.7921C48.7455 63.0248 48.8009 63.2757 48.978 63.545C49.1422 63.7946 49.3597 63.9504 49.6304 64.0123C49.9021 64.0704 50.2769 64.06 50.7546 63.9812C51.2334 63.8985 51.6321 63.8743 51.9509 63.9086C52.2706 63.9392 52.5464 64.0246 52.7781 64.165C53.0125 64.3041 53.215 64.5033 53.3857 64.7628C53.6578 65.1764 53.7435 65.5768 53.6428 65.9639C53.5447 66.3497 53.2719 66.687 52.8242 66.9759L53.2855 67.6771L52.7054 67.971L52.244 67.2698C51.7306 67.4745 51.2427 67.5063 50.7805 67.3651C50.3193 67.2203 49.9293 66.9055 49.6105 66.4209L50.3357 66.0535C50.5595 66.3937 50.8272 66.6072 51.1388 66.6941C51.4503 66.7811 51.7812 66.7358 52.1314 66.5584C52.4737 66.3849 52.6922 66.1714 52.7867 65.9179C52.8813 65.6644 52.8408 65.4043 52.6653 65.1375Z"
          fill="white"
          fillOpacity="0.25"
        />
        <path
          d="M32.4189 28.3898L17.8859 43.7702C16.9941 44.714 16.9941 46.2442 17.8859 47.1881L27.5746 57.4417C28.4664 58.3855 29.9123 58.3855 30.8041 57.4417L45.3371 42.0613C46.2289 41.1174 46.2289 39.5872 45.3371 38.6434L35.6485 28.3898C34.7566 27.4459 33.3107 27.4459 32.4189 28.3898Z"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.4189 28.3898L17.8859 43.7702C16.9941 44.714 16.9941 46.2442 17.8859 47.1881L27.5746 57.4417C28.4664 58.3855 29.9123 58.3855 30.8041 57.4417L45.3371 42.0613C46.2289 41.1174 46.2289 39.5872 45.3371 38.6434L35.6485 28.3898C34.7566 27.4459 33.3107 27.4459 32.4189 28.3898Z"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.114 50.6012L38.8704 31.8094"
          stroke="#F6F6F6"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.114 50.6012L38.8704 31.8094"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <defs>
        <clipPath id="clip0_66:17110">
          <path
            d="M2 8C2 3.58172 5.58172 0 10 0H324C328.418 0 332 3.58172 332 8V95C332 99.4183 328.418 103 324 103H9.99999C5.58171 103 2 99.4183 2 95V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const MoneyIcon = ({ sizeInPx, color, bcolor }) => {
  const size = sizeInPx ? sizeInPx : 56
  const mColor = color ? color : '#F6F6F6'
  const mBColor = bcolor ? bcolor : 'white'

  return (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_37_1624)">
        <path
          d="M8 12C8 7.58172 11.5817 4 16 4H40C44.4183 4 48 7.58172 48 12V36C48 40.4183 44.4183 44 40 44H16C11.5817 44 8 40.4183 8 36V12Z"
          fill="#00BBB6"
        />
        <path
          d="M28 15.875V17.75"
          stroke={mColor}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 15.875V17.75"
          stroke={mBColor}
          strokeOpacity="0.25"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 30.25V32.125"
          stroke={mColor}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 30.25V32.125"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.375 20.875C32.375 20.4646 32.2942 20.0583 32.1371 19.6791C31.9801 19.3 31.7499 18.9555 31.4597 18.6653C31.1695 18.3751 30.825 18.1449 30.4459 17.9879C30.0667 17.8308 29.6604 17.75 29.25 17.75H26.4375C25.6087 17.75 24.8138 18.0792 24.2278 18.6653C23.6417 19.2513 23.3125 20.0462 23.3125 20.875C23.3125 21.7038 23.6417 22.4987 24.2278 23.0847C24.8138 23.6708 25.6087 24 26.4375 24H29.875C30.7038 24 31.4987 24.3292 32.0847 24.9153C32.6708 25.5013 33 26.2962 33 27.125C33 27.9538 32.6708 28.7487 32.0847 29.3347C31.4987 29.9208 30.7038 30.25 29.875 30.25H26.125C25.2962 30.25 24.5013 29.9208 23.9153 29.3347C23.3292 28.7487 23 27.9538 23 27.125"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_37_1624"
          x="0"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_37_1624" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_37_1624" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

const CreditCardIcon = ({ sizeInPx, color, bcolor }) => {
  const size = sizeInPx ? sizeInPx : 57
  // const mColor = color ? color : '#F6F6F6'
  // const mBColor = bcolor ? bcolor : 'white'

  return (
    <svg width={size} height={size - 1} viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_37_1656)">
        <path
          d="M8.5 12C8.5 7.58172 12.0817 4 16.5 4H40.5C44.9183 4 48.5 7.58172 48.5 12V36C48.5 40.4183 44.9183 44 40.5 44H16.5C12.0817 44 8.5 40.4183 8.5 36V12Z"
          fill="#B70013"
        />
        <path
          d="M36 18.375H21C20.6548 18.375 20.375 18.6548 20.375 19V29C20.375 29.3452 20.6548 29.625 21 29.625H36C36.3452 29.625 36.625 29.3452 36.625 29V19C36.625 18.6548 36.3452 18.375 36 18.375Z"
          stroke="#F6F6F6"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36 18.375H21C20.6548 18.375 20.375 18.6548 20.375 19V29C20.375 29.3452 20.6548 29.625 21 29.625H36C36.3452 29.625 36.625 29.3452 36.625 29V19C36.625 18.6548 36.3452 18.375 36 18.375Z"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.6245 27.125H34.1245"
          stroke="#F6F6F6"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.6245 27.125H34.1245"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.8745 27.125H29.1245"
          stroke="#F6F6F6"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.8745 27.125H29.1245"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3745 21.5664H36.6245"
          stroke="#F6F6F6"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3745 21.5664H36.6245"
          stroke="white"
          strokeOpacity="0.25"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_37_1656"
          x="0.5"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_37_1656" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_37_1656" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

const InstituitionIcon = ({ sizeInPx, color, bcolor }) => {
  const size = sizeInPx ? sizeInPx : 57
  // const mColor = color ? color : '#F6F6F6'
  // const mBColor = bcolor ? bcolor : 'white'
  return (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_37_1637)">
        <path
          d="M8 12C8 7.58172 11.5817 4 16 4H40C44.4183 4 48 7.58172 48 12V36C48 40.4183 44.4183 44 40 44H16C11.5817 44 8 40.4183 8 36V12Z"
          fill="#1FA7CD"
        />
        <path
          d="M27.4582 32.889C24.3766 32.889 21.298 32.886 18.2163 32.8919C18.0448 32.8919 17.9945 32.8564 18.0005 32.679C18.0152 32.3123 18.0123 31.9455 18.0034 31.5788C18.0005 31.4427 18.0359 31.4043 18.1749 31.4043C18.935 31.4102 19.695 31.4073 20.4551 31.4073C25.8553 31.4073 31.2555 31.4073 36.6557 31.4043C36.842 31.4043 36.9012 31.4427 36.8923 31.6379C36.8746 31.9899 36.8775 32.3448 36.8923 32.6997C36.8982 32.8564 36.8539 32.8949 36.6971 32.8949C33.6185 32.889 30.5369 32.889 27.4582 32.889Z"
          fill="white"
        />
        <path
          d="M36.7119 20.4177C35.452 20.4236 34.1951 20.4206 32.9353 20.4206C32.607 20.4206 32.607 20.4206 32.5745 20.1042C32.3408 17.8063 30.5635 15.9135 28.2981 15.5527C28.165 15.532 28.1443 15.4788 28.1443 15.3635C28.1502 14.9642 28.1443 14.565 28.1473 14.1628C28.1473 14.0533 28.1354 13.9972 28.0023 14.0001C27.6031 14.009 27.2038 14.009 26.8016 14.0001C26.6893 14.0031 26.6656 14.0415 26.6656 14.148C26.6715 14.4496 26.6686 14.7513 26.6686 15.0529C26.6686 15.2097 26.7159 15.4049 26.6419 15.5113C26.5769 15.603 26.3699 15.5912 26.225 15.6267C24.0749 16.1324 22.4336 18.0665 22.3034 20.2639C22.2946 20.4117 22.2354 20.4265 22.1142 20.4265C20.804 20.4236 19.491 20.4265 18.1808 20.4206C18.0478 20.4206 18.0004 20.4443 18.0063 20.5892C18.0182 20.9766 18.0152 21.364 18.0063 21.7485C18.0034 21.8727 18.0418 21.9023 18.1601 21.8993C18.4825 21.8904 18.8019 21.9082 19.1242 21.8904C19.3046 21.8816 19.3372 21.9407 19.3372 22.1093C19.3313 24.7443 19.3342 27.3794 19.3283 30.0144C19.3283 30.2096 19.3697 30.2717 19.5767 30.2687C22.2058 30.2628 24.835 30.2628 27.4641 30.2628C30.0814 30.2628 32.6957 30.2599 35.313 30.2687C35.5082 30.2687 35.5703 30.2362 35.5703 30.0233C35.5615 27.3823 35.5674 24.7384 35.5615 22.0975C35.5615 21.9407 35.5881 21.8816 35.7596 21.8904C36.0879 21.9052 36.4161 21.8904 36.7415 21.8964C36.8597 21.8993 36.9012 21.8697 36.8982 21.7455C36.8893 21.364 36.8893 20.9855 36.8982 20.604C36.8982 20.4591 36.8627 20.4177 36.7119 20.4177ZM22.0905 28.7989C21.7238 28.7871 21.3571 28.79 20.9904 28.7989C20.8514 28.8019 20.8011 28.7782 20.8011 28.6215C20.807 26.433 20.807 24.2475 20.8011 22.059C20.8011 21.9141 20.8484 21.8875 20.9785 21.8904C21.3512 21.8993 21.7268 21.9023 22.0994 21.8904C22.2502 21.8845 22.2827 21.9348 22.2827 22.0797C22.2768 23.168 22.2798 24.2534 22.2798 25.3417C22.2798 26.43 22.2768 27.5154 22.2827 28.6037C22.2857 28.7516 22.2502 28.8048 22.0905 28.7989ZM23.7792 20.2254C24.0217 18.4747 25.2815 17.2089 27.0353 16.9753C28.9073 16.7239 30.7823 18.1227 31.078 19.9948C31.1461 20.4236 31.1461 20.4236 30.7084 20.4236C29.62 20.4236 28.5317 20.4236 27.4464 20.4236C26.2871 20.4236 25.1278 20.4206 23.9685 20.4265C23.8028 20.4265 23.7526 20.4058 23.7792 20.2254ZM28.0142 28.7989C27.6208 28.79 27.2275 28.793 26.8342 28.7989C26.7159 28.8019 26.6626 28.7841 26.6626 28.6422C26.6686 27.6337 26.6626 26.6252 26.6686 25.6168C26.6715 25.182 27.0027 24.8478 27.4227 24.8478C27.8308 24.8449 28.165 25.1613 28.1768 25.5931C28.1887 26.1047 28.1798 26.6134 28.1798 27.125C28.1798 27.125 28.1798 27.125 28.1827 27.125C28.1827 27.6219 28.1798 28.1217 28.1857 28.6185C28.1857 28.7457 28.162 28.8019 28.0142 28.7989ZM31.1697 28.6008C31.1697 28.7486 31.1401 28.8048 30.9775 28.7989C30.5989 28.7871 30.2174 28.7871 29.8359 28.7989C29.691 28.8019 29.6496 28.7693 29.6496 28.6185C29.6585 27.6367 29.6555 26.6519 29.6526 25.67C29.6526 24.4959 28.9014 23.6028 27.748 23.4017C26.5118 23.1858 25.249 24.1706 25.2076 25.4245C25.1721 26.4715 25.1899 27.5213 25.1958 28.5712C25.1958 28.7664 25.1396 28.8108 24.9562 28.8019C24.6043 28.7871 24.2494 28.793 23.8945 28.7989C23.7851 28.8019 23.7496 28.7753 23.7496 28.6599C23.7526 26.4507 23.7526 24.2416 23.7496 22.0324C23.7496 21.8904 23.8176 21.8964 23.9182 21.8964C25.0982 21.8993 26.2782 21.8964 27.4582 21.8964C28.6264 21.8964 29.7916 21.8993 30.9597 21.8934C31.1165 21.8934 31.1697 21.923 31.1697 22.0945C31.1668 24.2593 31.1668 26.43 31.1697 28.6008ZM34.0857 28.6422C34.0857 28.7634 34.0502 28.7989 33.929 28.796C33.5563 28.79 33.1807 28.7871 32.8081 28.796C32.6602 28.7989 32.6395 28.7457 32.6425 28.6156C32.6484 27.5213 32.6455 26.4271 32.6455 25.3329C32.6455 24.2445 32.6484 23.1592 32.6425 22.0708C32.6425 21.9259 32.6721 21.8786 32.8229 21.8845C33.1896 21.8964 33.5563 21.8934 33.9231 21.8875C34.0354 21.8845 34.0857 21.9082 34.0857 22.0354C34.0828 24.2416 34.0828 26.4419 34.0857 28.6422Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_37_1637"
          x="0"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_37_1637" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_37_1637" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

const CircleArrowRight = ({ sizeInPx, color, bcolor }) => {
  const size = sizeInPx ? sizeInPx : 30
  const mColor = color ? color : '#2396B6'
  const mBColor = bcolor ? bcolor : '#1fa7cd38'

  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={size} height={size} rx={size / 2} fill={mBColor} fillOpacity="1" />
      <path
        d="M9.75 15H20.25"
        stroke={mColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9.75L20.25 15L15 20.25"
        stroke={mColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const LOC = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#DDF6F6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4915 7.52917C15.9571 7.52917 17.1452 8.69556 17.1452 10.1344C17.1452 11.5732 15.9571 12.7395 14.4915 12.7395C13.0259 12.7395 11.8378 11.5732 11.8378 10.1344C11.8378 8.69556 13.0259 7.52917 14.4915 7.52917ZM20.6841 10.1358C22.1497 10.1358 23.3378 11.3022 23.3378 12.741C23.3378 14.1798 22.1497 15.3462 20.6841 15.3462C19.2185 15.3462 18.0304 14.1798 18.0304 12.741C18.0304 11.3022 19.2185 10.1358 20.6841 10.1358ZM9.18516 13.607C9.67369 13.607 10.0697 13.9958 10.0697 14.4754C11.4595 14.4734 12.8092 14.9325 13.8999 15.778H15.8194C16.9985 15.778 18.0573 16.2817 18.7862 17.0806H21.569C23.2756 17.0802 24.8302 18.0437 25.5637 19.5564C23.4717 22.2667 20.0847 24.0278 16.2617 24.0278C13.7937 24.0278 11.7062 23.5042 10.0166 22.588C9.88987 22.9315 9.5573 23.16 9.18516 23.1594H6.53147C6.04294 23.1594 5.64691 22.7706 5.64691 22.291V14.4754C5.64691 13.9958 6.04294 13.607 6.53147 13.607H9.18516ZM10.071 16.2138L10.0701 20.5749L10.1099 20.6027C11.6977 21.6969 13.7658 22.2926 16.262 22.2926C18.9193 22.2926 21.3916 21.2887 23.1926 19.5745L23.3102 19.459L23.2041 19.3722C22.7864 19.051 22.2801 18.8604 21.7508 18.8251L21.5694 18.819H19.7021C19.7658 19.0986 19.8003 19.3887 19.8003 19.6874V20.5558H11.8392V18.819L17.8454 18.8182L17.8153 18.7504C17.4702 18.0424 16.7627 17.5722 15.9648 17.5208L15.8198 17.5164H13.228C12.3976 16.6826 11.2597 16.213 10.0719 16.2138H10.071ZM7.41637 15.3452H8.30093V21.424H7.41637V15.3452ZM19.7999 12.739C19.7999 12.2594 20.196 11.8706 20.6845 11.8706C21.173 11.8706 21.569 12.2594 21.569 12.739C21.569 13.2186 21.173 13.6074 20.6845 13.6074C20.196 13.6074 19.7999 13.2186 19.7999 12.739ZM13.6081 10.1365C13.6081 9.65694 14.0041 9.26815 14.4926 9.26815C14.9812 9.26815 15.3772 9.65694 15.3772 10.1365C15.3772 10.6161 14.9812 11.0049 14.4926 11.0049C14.0041 11.0049 13.6081 10.6161 13.6081 10.1365Z"
        fill="#00C9C6"
      />
    </svg>
  )
}

const InfoIconBtn = () => {
  return <IoInformationCircleOutline />
}

const ChevronLeftBtn = () => {
  return <BiChevronLeft />
}

const ChevronRightBtn = () => {
  return <BiChevronRight />
}

const PropellCard1 = () => {
  return (
    // <svg width="100%" height="136" viewBox="0 0 355 136" fill="none" xmlns="http://www.w3.org/2000/svg">
    <svg width="100" height="100" viewBox="0 0 79 136" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_66:17162)">
        <path
          d="M55.7542 89.831V80.3406"
          stroke="#197BBD"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.01 85.0858L55.7552 80.3406L60.5005 85.0858"
          stroke="#197BBD"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip0_66:17162)">
          <path
            d="M35.5542 88.8677L22.6831 101.739C21.8932 102.529 21.8932 103.809 22.6831 104.599L31.2638 113.18C32.0536 113.97 33.3342 113.97 34.124 113.18L46.9952 100.309C47.785 99.5189 47.785 98.2383 46.9952 97.4484L38.4144 88.8677C37.6246 88.0779 36.344 88.0779 35.5542 88.8677Z"
            stroke="#197BBD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.5436 107.457L41.2749 91.7253"
            stroke="#197BBD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M83.326 41.6556C83.1749 43.291 82.5611 44.8495 81.5566 46.1488C80.552 47.4481 79.1982 48.4344 77.6536 48.9923C76.1089 49.5503 74.4373 49.6567 72.8343 49.2993C71.2313 48.9419 69.7633 48.1353 68.602 46.974C67.4407 45.8127 66.6341 44.3447 66.2767 42.7417C65.9193 41.1387 66.0258 39.4671 66.5837 37.9225C67.1417 36.3778 68.128 35.024 69.4273 34.0194C70.7265 33.0149 72.2851 32.4011 73.9204 32.25C72.963 33.5453 72.5022 35.1413 72.622 36.7476C72.7418 38.3539 73.4342 39.8639 74.5731 41.0029C75.7121 42.1419 77.2221 42.8342 78.8284 42.954C80.4347 43.0738 82.0307 42.6131 83.326 41.6556V41.6556Z"
          stroke="#197BBD"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.75 38H32.75C30.6875 38 29.0187 39.665 29.0187 41.7L29 71.3C29 73.335 30.6687 75 32.7312 75H55.25C57.3125 75 59 73.335 59 71.3V49.1L47.75 38Z"
          fill="white"
          stroke="#DAE4ED"
        />
        <path
          d="M30 60.4905V51"
          stroke="#197BBD"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="26.0363"
          cy="21.0453"
          r="11.7215"
          transform="rotate(-30 26.0363 21.0453)"
          stroke="#197BBD"
          strokeWidth="1.5"
        />
        <path
          d="M28.7348 22.3192C28.538 21.9783 28.2676 21.7601 27.9237 21.6645C27.5774 21.565 27.1007 21.5729 26.4935 21.6881C25.884 21.7994 25.3949 21.8599 25.0262 21.8696C23.8023 21.9078 22.9067 21.4356 22.3394 20.453C21.955 19.7873 21.8415 19.1229 21.9988 18.4599C22.1561 17.7969 22.5585 17.225 23.206 16.7442L22.4489 15.4328L23.4114 14.8771L24.1755 16.2006C24.9312 15.8979 25.642 15.8833 26.3078 16.1566C26.9713 16.4259 27.5299 16.9536 27.9837 17.7397L26.5279 18.5802C26.2362 18.0749 25.8927 17.7438 25.4973 17.587C25.1037 17.4239 24.7124 17.4547 24.3234 17.6793C23.9384 17.9016 23.6978 18.1795 23.6016 18.5131C23.5055 18.8467 23.5697 19.208 23.7943 19.597C23.9957 19.9459 24.2641 20.1653 24.5994 20.2551C24.9363 20.3386 25.4159 20.3264 26.0381 20.2185C26.6603 20.1107 27.164 20.0524 27.5494 20.0438C27.9348 20.0352 28.288 20.0773 28.6089 20.1701C28.9275 20.2588 29.2185 20.4063 29.4819 20.6125C29.7454 20.8187 29.9813 21.1022 30.1897 21.4632C30.581 22.1409 30.6897 22.8108 30.5157 23.4727C30.3457 24.1323 29.9118 24.7144 29.2138 25.2189L29.8911 26.392L28.9346 26.9443L28.2608 25.7772C27.4158 26.1474 26.6398 26.2158 25.9328 25.9823C25.2298 25.7465 24.6491 25.2315 24.1906 24.4374L25.6525 23.5934C25.9442 24.0988 26.2963 24.4169 26.7087 24.5477C27.1252 24.6762 27.566 24.6062 28.0312 24.3376C28.4884 24.0737 28.7717 23.7631 28.8809 23.4059C28.9942 23.0464 28.9455 22.6841 28.7348 22.3192Z"
          fill="#197BBD"
        />
        <path
          d="M25.0679 50.546L29.8131 45.8008L34.5583 50.546"
          stroke="#197BBD"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_66:17162"
          x="0"
          y="0"
          width="355"
          height="136"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_66:17162" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_66:17162" result="shape" />
        </filter>
        <clipPath id="clip0_66:17162">
          <rect
            width="24.27"
            height="24.27"
            fill="white"
            transform="translate(17.6787 101.023) rotate(-45)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const ArrowLeft = ({ sizeInPx, color }) => {
  const size = sizeInPx ? sizeInPx : 19
  const mColor = color ? color : 'black'
  return (
    <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.0312 9.5H2.96875"
        stroke={mColor}
        strokeWidth="1.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3125 4.15625L2.96875 9.5L8.3125 14.8438"
        stroke={mColor}
        strokeWidth="1.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const ArrowRight = ({ sizeInPx, color }) => {
  const size = sizeInPx ? sizeInPx : 32
  const mColor = color ? color : 'black'
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 16H27" stroke={mColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18 7L27 16L18 25"
        stroke={mColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const ArrowRight2 = ({ sizeInPx, color }) => {
  const size = sizeInPx ? sizeInPx : 15
  const mColor = color ? color : 'white'
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.6875 7.5H12.3125"
        stroke={mColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.375 3.5625L12.3125 7.5L8.375 11.4375"
        stroke={mColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const LoanIcon = ({ sizeInPx, color }) => {
  const size = sizeInPx ? sizeInPx : 56
  const mColor = color ? color : '#1FA7CD'

  return (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_10_132035)">
        <path
          d="M8 12C8 7.58172 11.5817 4 16 4H40C44.4183 4 48 7.58172 48 12V36C48 40.4183 44.4183 44 40 44H16C11.5817 44 8 40.4183 8 36V12Z"
          fill={mColor}
        />
        <path
          d="M37.6392 28.1993C37.2929 27.853 36.9466 27.6798 36.5137 27.5067C35.4747 27.2469 34.5223 27.4201 33.7431 28.1127C33.1371 28.6322 32.6176 29.2383 32.0115 29.8443C31.9249 29.9309 31.9249 29.9309 31.8384 29.9309C31.5786 29.9309 31.4055 29.9309 31.0591 29.9309C31.4055 29.4114 31.5786 28.8919 31.5786 28.2859C31.5786 27.853 31.4055 27.5932 30.886 27.5932C30.3665 27.5932 29.7604 27.5932 29.241 27.5932C28.8081 27.5932 28.4617 27.5067 28.1154 27.4201C27.6825 27.2469 27.2496 27.0738 26.8167 26.814C25.6046 26.208 24.3925 26.1214 23.1803 26.4677C22.3145 26.6409 21.7085 27.1603 21.5353 28.1127C21.5353 28.1993 21.4487 28.1993 21.3622 28.1993C20.8427 28.1993 20.2366 28.1993 19.7171 28.1993C19.2842 28.1993 19.1111 28.459 19.1111 28.8054C19.1111 30.2772 19.1111 31.7491 19.1111 33.3075C19.1111 33.7404 19.3708 33.9136 19.7171 33.9136C23.6998 33.9136 27.6825 33.9136 31.6652 33.9136C32.3578 33.9136 32.9639 33.6538 33.3968 33.2209C34.8687 31.8357 36.2539 30.3638 37.6392 28.9785C37.899 28.8054 37.899 28.459 37.6392 28.1993ZM21.3622 32.788C21.0158 32.788 20.7561 32.788 20.4098 32.788C20.3232 32.788 20.2366 32.788 20.2366 32.6149C20.2366 31.5759 20.2366 30.537 20.2366 29.498C20.2366 29.4114 20.2366 29.3248 20.4098 29.3248C20.7561 29.3248 21.0158 29.3248 21.3622 29.3248C21.5353 29.3248 21.5353 29.4114 21.5353 29.498C21.5353 30.0175 21.5353 30.537 21.5353 31.0564C21.5353 31.5759 21.5353 32.0954 21.5353 32.5283C21.6219 32.788 21.5353 32.8746 21.3622 32.788ZM36.1674 28.8919C35.0418 30.0175 33.8297 31.2296 32.7042 32.3551C32.3578 32.7015 32.0115 32.788 31.5786 32.788C28.7215 32.788 25.8643 32.788 23.0072 32.788C22.834 32.788 22.7474 32.7015 22.7474 32.5283C22.7474 31.143 22.7474 29.8443 22.7474 28.459C22.7474 27.9396 22.9206 27.7664 23.4401 27.5932C24.4791 27.3335 25.518 27.4201 26.557 27.9396C27.2496 28.2859 27.9423 28.6322 28.6349 28.7188C28.8946 28.7188 29.0678 28.8054 29.3275 28.8054C29.6739 28.8054 30.0202 28.8054 30.3665 28.8054C30.1933 29.3248 29.6739 29.8443 29.0678 29.9309C28.8946 29.9309 28.7215 29.9309 28.5483 29.9309C27.6825 29.9309 26.9033 29.9309 26.0375 29.9309C25.9509 29.9309 25.7778 29.9309 25.6912 29.9309C25.4314 30.0175 25.2583 30.2772 25.2583 30.537C25.2583 30.7967 25.518 31.0564 25.7778 31.0564C26.0375 31.0564 26.2972 31.0564 26.4704 31.0564C28.2886 31.0564 30.1068 31.0564 32.0115 31.0564C32.2713 31.0564 32.531 30.9699 32.7042 30.7967C33.3102 30.1906 33.9163 29.5846 34.5223 28.9785C35.0418 28.459 35.7345 28.3725 36.3405 28.6322C36.3405 28.8054 36.2539 28.8054 36.1674 28.8919Z"
          fill="white"
        />
        <path
          d="M30.3666 19.5412C30.0203 19.4546 29.7606 19.2815 29.4142 19.1083C29.2411 19.0217 29.1545 18.9352 29.2411 18.762C29.2411 18.5888 29.3277 18.4157 29.5874 18.4157C29.8471 18.3291 30.0203 18.4157 30.28 18.5023C30.3666 18.5888 30.5398 18.6754 30.7129 18.6754C30.9727 18.6754 31.1458 18.5023 31.2324 18.3291C31.319 18.0694 31.2324 17.8096 31.0593 17.6365C30.8861 17.4633 30.7129 17.3767 30.5398 17.3767C30.4532 17.3767 30.3666 17.2901 30.3666 17.2036C30.3666 16.8572 30.1069 16.6841 29.7606 16.6841C29.4142 16.6841 29.1545 16.9438 29.1545 17.2036C29.1545 17.3767 29.0679 17.3767 28.9813 17.4633C28.3753 17.723 28.029 18.4157 28.1155 19.1083C28.2021 19.5412 28.3753 19.8875 28.8082 20.1473C29.1545 20.407 29.5874 20.5802 30.0203 20.7533C30.3666 20.9265 30.5398 21.2728 30.28 21.6191C30.1935 21.7057 29.9337 21.7923 29.674 21.7923C29.3277 21.7923 29.0679 21.7923 28.7216 21.5326C28.4619 21.3594 28.1155 21.446 27.9424 21.7057C27.7692 21.9655 27.8558 22.3118 28.1155 22.4849C28.3753 22.6581 28.635 22.8313 28.8948 22.8313C28.9813 22.8313 29.0679 22.9178 29.0679 23.0044C29.0679 23.3507 29.3277 23.6105 29.674 23.5239C30.0203 23.5239 30.28 23.2642 30.28 22.9178C30.28 22.8313 30.28 22.7447 30.4532 22.6581C31.1458 22.3118 31.5787 21.6191 31.5787 20.9265C31.4922 20.407 31.1458 19.801 30.3666 19.5412Z"
          fill="white"
        />
        <path
          d="M29.7606 14C26.3839 14 23.7 16.7706 23.7 20.1472C23.7 23.5238 26.3839 26.2944 29.7606 26.2944C33.1372 26.2944 35.8212 23.5238 35.8212 20.1472C35.8212 16.7706 33.1372 14 29.7606 14ZM29.7606 25.0823C27.0766 25.0823 24.8255 22.8312 24.9121 20.1472C24.9121 17.3766 27.1632 15.2121 29.8471 15.2121C32.5311 15.2121 34.7822 17.4632 34.7822 20.1472C34.6956 22.9177 32.4445 25.0823 29.7606 25.0823Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_10_132035"
          x="0"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10_132035" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10_132035" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

const TimerIcon = ({ sizeInPx, color, bcolor }) => {
  const size = sizeInPx ? sizeInPx : 56
  const mColor = color ? color : 'black'
  const mBColor = bcolor ? bcolor : 'white'

  return (
    <svg width={size} height={size} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_10_132044)">
        <rect width="40" height="40" transform="translate(3 2)" fill="white" />
        <path
          d="M3 10C3 5.58172 6.58172 2 11 2H35C39.4183 2 43 5.58172 43 10V34C43 38.4183 39.4183 42 35 42H11C6.58172 42 3 38.4183 3 34V10Z"
          fill={mBColor}
        />
        <path
          d="M23 28.875C26.797 28.875 29.875 25.797 29.875 22C29.875 18.203 26.797 15.125 23 15.125C19.203 15.125 16.125 18.203 16.125 22C16.125 25.797 19.203 28.875 23 28.875Z"
          stroke={mColor}
          strokeWidth="1.6"
          strokeMiterlimit="10"
        />
        <path
          d="M23 21.9998L26.0936 18.9062"
          stroke={mColor}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.125 12.625H24.875"
          stroke={mColor}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_10_132044"
          x="0"
          y="0"
          width="46"
          height="46"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10_132044" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend mode="normal" in2="effect1_dropShadow_10_132044" result="effect2_dropShadow_10_132044" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_10_132044" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

const Timer3 = () => {
  return (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2656 0.0574415H1.35598C0.984741 0.0574415 0.719573 0.349126 0.719573 0.693844V1.11811C0.719573 1.48935 0.984741 1.75451 1.35598 1.75451C1.35598 4.16754 2.70833 6.20933 4.53799 6.84573C2.70833 7.50865 1.35598 9.55044 1.35598 11.937C0.984741 11.937 0.719573 12.2286 0.719573 12.5734V12.9976C0.719573 13.3689 0.984741 13.634 1.35598 13.634H10.2656C10.6103 13.634 10.902 13.3689 10.902 12.9976V12.5734C10.902 12.2286 10.6103 11.937 10.2656 11.937C10.2656 9.55044 8.88674 7.50865 7.05708 6.84573C8.88674 6.20933 10.2656 4.16754 10.2656 1.75451C10.6103 1.75451 10.902 1.48935 10.902 1.11811V0.693844C10.902 0.349126 10.6103 0.0574415 10.2656 0.0574415ZM8.25033 10.2399H3.34473C3.79552 9.02011 4.7236 8.11854 5.81079 8.11854C6.87146 8.11854 7.79955 9.02011 8.25033 10.2399ZM8.25033 3.45159H3.34473C3.1326 2.94777 3.05305 2.3644 3.05305 1.75451H8.56853C8.56853 2.3644 8.46247 2.94777 8.25033 3.45159Z"
        fill="#7C7C7C"
      />
    </svg>
  )
}

const PencilSimple = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 26.9998H6C5.73478 26.9998 5.48043 26.8945 5.29289 26.707C5.10536 26.5194 5 26.2651 5 25.9998V20.4141C5 20.2827 5.02587 20.1527 5.07612 20.0314C5.12638 19.9101 5.20004 19.7998 5.29289 19.707L20.2929 4.70695C20.4804 4.51942 20.7348 4.41406 21 4.41406C21.2652 4.41406 21.5196 4.51942 21.7071 4.70695L27.2929 10.2927C27.4804 10.4803 27.5858 10.7346 27.5858 10.9998C27.5858 11.2651 27.4804 11.5194 27.2929 11.707L12 26.9998Z"
        stroke="#5490DA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17 8L24 15" stroke="#5490DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const PropellHourGlass = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 10L5.25 6.4375C5.17238 6.37928 5.10938 6.30379 5.06598 6.21701C5.02259 6.13022 5 6.03453 5 5.9375V3.125C5 2.95924 5.06585 2.80027 5.18306 2.68306C5.30027 2.56585 5.45924 2.5 5.625 2.5H14.375C14.5408 2.5 14.6997 2.56585 14.8169 2.68306C14.9342 2.80027 15 2.95924 15 3.125V5.90947C15 6.0061 14.9776 6.10141 14.9345 6.18792C14.8915 6.27443 14.829 6.34978 14.7519 6.40805L10 10Z"
        stroke="#273869"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10L5.25 13.5625C5.17238 13.6207 5.10938 13.6962 5.06598 13.783C5.02259 13.8698 5 13.9655 5 14.0625V16.875C5 17.0408 5.06585 17.1997 5.18306 17.3169C5.30027 17.4342 5.45924 17.5 5.625 17.5H14.375C14.5408 17.5 14.6997 17.4342 14.8169 17.3169C14.9342 17.1997 15 17.0408 15 16.875V14.0905C15 13.9939 14.9776 13.8986 14.9345 13.8121C14.8915 13.7256 14.829 13.6502 14.7519 13.5919L10 10Z"
        stroke="#273869"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83203 6.875H14.1338"
        stroke="#273869"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.1246V10"
        stroke="#273869"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const PropellOverDue = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="9" fill="#EF404A" />
      <path d="M9 6V9.5" stroke="#EFEFEF" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 6V9.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.2782 3H6.72183C6.65616 3 6.59115 3.01293 6.53048 3.03806C6.46982 3.06319 6.4147 3.10002 6.36827 3.14645L3.14645 6.36827C3.10002 6.4147 3.06319 6.46982 3.03806 6.53048C3.01293 6.59115 3 6.65616 3 6.72183V11.2782C3 11.3438 3.01293 11.4089 3.03806 11.4695C3.06319 11.5302 3.10002 11.5853 3.14645 11.6317L6.36827 14.8536C6.4147 14.9 6.46982 14.9368 6.53048 14.9619C6.59115 14.9871 6.65616 15 6.72183 15H11.2782C11.3438 15 11.4089 14.9871 11.4695 14.9619C11.5302 14.9368 11.5853 14.9 11.6317 14.8536L14.8536 11.6317C14.9 11.5853 14.9368 11.5302 14.9619 11.4695C14.9871 11.4089 15 11.3438 15 11.2782V6.72183C15 6.65616 14.9871 6.59115 14.9619 6.53048C14.9368 6.46982 14.9 6.4147 14.8536 6.36827L11.6317 3.14645C11.5853 3.10002 11.5302 3.06319 11.4695 3.03806C11.4089 3.01293 11.3438 3 11.2782 3Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M9 12.5C9.41421 12.5 9.75 12.1642 9.75 11.75C9.75 11.3358 9.41421 11 9 11C8.58579 11 8.25 11.3358 8.25 11.75C8.25 12.1642 8.58579 12.5 9 12.5Z"
        fill="#EFEFEF"
      />
      <path
        d="M9 12.5C9.41421 12.5 9.75 12.1642 9.75 11.75C9.75 11.3358 9.41421 11 9 11C8.58579 11 8.25 11.3358 8.25 11.75C8.25 12.1642 8.58579 12.5 9 12.5Z"
        fill="white"
      />
    </svg>
  )
}

const PropellOverDueRepayment = () => {
  return (
    <svg width="144" height="28" viewBox="0 0 144 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.1" x="1" y="1" width="135" height="26" rx="13" stroke="#EF404A" />
      <circle cx="16" cy="14" r="9" fill="#EF404A" />
      <path d="M16 11V14.5" stroke="#EFEFEF" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 11V14.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18.2782 8H13.7218C13.6562 8 13.5911 8.01293 13.5305 8.03806C13.4698 8.06319 13.4147 8.10002 13.3683 8.14645L10.1464 11.3683C10.1 11.4147 10.0632 11.4698 10.0381 11.5305C10.0129 11.5911 10 11.6562 10 11.7218V16.2782C10 16.3438 10.0129 16.4089 10.0381 16.4695C10.0632 16.5302 10.1 16.5853 10.1464 16.6317L13.3683 19.8536C13.4147 19.9 13.4698 19.9368 13.5305 19.9619C13.5911 19.9871 13.6562 20 13.7218 20H18.2782C18.3438 20 18.4089 19.9871 18.4695 19.9619C18.5302 19.9368 18.5853 19.9 18.6317 19.8536L21.8536 16.6317C21.9 16.5853 21.9368 16.5302 21.9619 16.4695C21.9871 16.4089 22 16.3438 22 16.2782V11.7218C22 11.6562 21.9871 11.5911 21.9619 11.5305C21.9368 11.4698 21.9 11.4147 21.8536 11.3683L18.6317 8.14645C18.5853 8.10002 18.5302 8.06319 18.4695 8.03806C18.4089 8.01293 18.3438 8 18.2782 8Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M16 17.5C16.4142 17.5 16.75 17.1642 16.75 16.75C16.75 16.3358 16.4142 16 16 16C15.5858 16 15.25 16.3358 15.25 16.75C15.25 17.1642 15.5858 17.5 16 17.5Z"
        fill="#EFEFEF"
      />
      <path
        d="M16 17.5C16.4142 17.5 16.75 17.1642 16.75 16.75C16.75 16.3358 16.4142 16 16 16C15.5858 16 15.25 16.3358 15.25 16.75C15.25 17.1642 15.5858 17.5 16 17.5Z"
        fill="white"
      />
      <path
        d="M37.2842 13.6309C37.2842 14.3275 37.1637 14.9395 36.9229 15.4668C36.682 15.9909 36.3369 16.3945 35.8877 16.6777C35.4417 16.9577 34.9274 17.0977 34.3447 17.0977C33.7686 17.0977 33.2542 16.9577 32.8018 16.6777C32.3525 16.3945 32.0042 15.9925 31.7568 15.4717C31.5127 14.9508 31.389 14.3503 31.3857 13.6699V13.2695C31.3857 12.5762 31.5078 11.9642 31.752 11.4336C31.9993 10.903 32.346 10.4977 32.792 10.2178C33.2412 9.93457 33.7555 9.79297 34.335 9.79297C34.9144 9.79297 35.4271 9.93294 35.873 10.2129C36.3223 10.4896 36.6689 10.89 36.9131 11.4141C37.1572 11.9349 37.2809 12.542 37.2842 13.2354V13.6309ZM36.0488 13.2598C36.0488 12.472 35.8991 11.8682 35.5996 11.4482C35.3034 11.0283 34.8818 10.8184 34.335 10.8184C33.8011 10.8184 33.3828 11.0283 33.0801 11.4482C32.7806 11.8649 32.6276 12.4557 32.6211 13.2207V13.6309C32.6211 14.4121 32.7725 15.016 33.0752 15.4424C33.3812 15.8688 33.8044 16.082 34.3447 16.082C34.8916 16.082 35.3115 15.8737 35.6045 15.457C35.9007 15.0404 36.0488 14.4316 36.0488 13.6309V13.2598ZM40.2627 15.4961L41.3809 11.7168H42.6064L40.7754 17H39.7451L37.8994 11.7168H39.1299L40.2627 15.4961ZM45.6094 17.0977C44.8574 17.0977 44.2471 16.8617 43.7783 16.3896C43.3128 15.9144 43.0801 15.2829 43.0801 14.4951V14.3486C43.0801 13.8213 43.181 13.3509 43.3828 12.9375C43.5879 12.5208 43.8743 12.1969 44.2422 11.9658C44.61 11.7347 45.0202 11.6191 45.4727 11.6191C46.1921 11.6191 46.7471 11.8486 47.1377 12.3076C47.5316 12.7666 47.7285 13.416 47.7285 14.2559V14.7344H44.2764C44.3122 15.1706 44.457 15.5156 44.7109 15.7695C44.9681 16.0234 45.2904 16.1504 45.6777 16.1504C46.2214 16.1504 46.6641 15.9307 47.0059 15.4912L47.6455 16.1016C47.4339 16.4173 47.1507 16.6631 46.7959 16.8389C46.4443 17.0114 46.0488 17.0977 45.6094 17.0977ZM45.4678 12.5713C45.1423 12.5713 44.8786 12.6852 44.6768 12.9131C44.4782 13.141 44.3512 13.4583 44.2959 13.8652H46.5566V13.7773C46.5306 13.3802 46.4248 13.0807 46.2393 12.8789C46.0537 12.6738 45.7965 12.5713 45.4678 12.5713ZM51.4199 12.8008C51.2637 12.7747 51.1025 12.7617 50.9365 12.7617C50.3929 12.7617 50.0267 12.9701 49.8379 13.3867V17H48.6514V11.7168H49.7842L49.8135 12.3076C50.0999 11.8486 50.4971 11.6191 51.0049 11.6191C51.1742 11.6191 51.3141 11.6419 51.4248 11.6875L51.4199 12.8008ZM51.8496 14.3193C51.8496 13.5055 52.0384 12.8529 52.416 12.3613C52.7936 11.8665 53.2998 11.6191 53.9346 11.6191C54.4945 11.6191 54.9469 11.8145 55.292 12.2051V9.5H56.4785V17H55.4043L55.3457 16.4531C54.9909 16.8828 54.5173 17.0977 53.9248 17.0977C53.3063 17.0977 52.805 16.8486 52.4209 16.3506C52.04 15.8525 51.8496 15.1755 51.8496 14.3193ZM53.0361 14.4219C53.0361 14.959 53.1387 15.3789 53.3438 15.6816C53.5521 15.9811 53.8467 16.1309 54.2275 16.1309C54.7126 16.1309 55.0674 15.9144 55.292 15.4814V13.2256C55.0739 12.8024 54.7223 12.5908 54.2373 12.5908C53.8532 12.5908 53.557 12.7438 53.3486 13.0498C53.1403 13.3525 53.0361 13.8099 53.0361 14.4219ZM60.917 16.4824C60.5687 16.8926 60.0739 17.0977 59.4326 17.0977C58.8597 17.0977 58.4251 16.93 58.1289 16.5947C57.8359 16.2594 57.6895 15.7744 57.6895 15.1396V11.7168H58.876V15.125C58.876 15.7956 59.1543 16.1309 59.7109 16.1309C60.2871 16.1309 60.6761 15.9242 60.8779 15.5107V11.7168H62.0645V17H60.9463L60.917 16.4824ZM65.5996 17.0977C64.8477 17.0977 64.2373 16.8617 63.7686 16.3896C63.3031 15.9144 63.0703 15.2829 63.0703 14.4951V14.3486C63.0703 13.8213 63.1712 13.3509 63.373 12.9375C63.5781 12.5208 63.8646 12.1969 64.2324 11.9658C64.6003 11.7347 65.0104 11.6191 65.4629 11.6191C66.1823 11.6191 66.7373 11.8486 67.1279 12.3076C67.5218 12.7666 67.7188 13.416 67.7188 14.2559V14.7344H64.2666C64.3024 15.1706 64.4473 15.5156 64.7012 15.7695C64.9583 16.0234 65.2806 16.1504 65.668 16.1504C66.2116 16.1504 66.6543 15.9307 66.9961 15.4912L67.6357 16.1016C67.4242 16.4173 67.141 16.6631 66.7861 16.8389C66.4346 17.0114 66.0391 17.0977 65.5996 17.0977ZM65.458 12.5713C65.1325 12.5713 64.8688 12.6852 64.667 12.9131C64.4684 13.141 64.3415 13.4583 64.2861 13.8652H66.5469V13.7773C66.5208 13.3802 66.415 13.0807 66.2295 12.8789C66.0439 12.6738 65.7868 12.5713 65.458 12.5713ZM73.8613 14.2607H72.4844V17H71.249V9.89062H73.749C74.5693 9.89062 75.2025 10.0745 75.6484 10.4424C76.0944 10.8102 76.3174 11.3424 76.3174 12.0391C76.3174 12.5143 76.2018 12.9131 75.9707 13.2354C75.7428 13.5544 75.4238 13.8001 75.0137 13.9727L76.6104 16.9365V17H75.2871L73.8613 14.2607ZM72.4844 13.2695H73.7539C74.1706 13.2695 74.4961 13.1654 74.7305 12.957C74.9648 12.7454 75.082 12.4574 75.082 12.0928C75.082 11.7119 74.973 11.4173 74.7549 11.209C74.54 11.0007 74.2178 10.8932 73.7881 10.8867H72.4844V13.2695ZM79.7012 17.0977C78.9492 17.0977 78.3389 16.8617 77.8701 16.3896C77.4046 15.9144 77.1719 15.2829 77.1719 14.4951V14.3486C77.1719 13.8213 77.2728 13.3509 77.4746 12.9375C77.6797 12.5208 77.9661 12.1969 78.334 11.9658C78.7018 11.7347 79.112 11.6191 79.5645 11.6191C80.2839 11.6191 80.8389 11.8486 81.2295 12.3076C81.6234 12.7666 81.8203 13.416 81.8203 14.2559V14.7344H78.3682C78.404 15.1706 78.5488 15.5156 78.8027 15.7695C79.0599 16.0234 79.3822 16.1504 79.7695 16.1504C80.3132 16.1504 80.7559 15.9307 81.0977 15.4912L81.7373 16.1016C81.5257 16.4173 81.2425 16.6631 80.8877 16.8389C80.5361 17.0114 80.1406 17.0977 79.7012 17.0977ZM79.5596 12.5713C79.234 12.5713 78.9704 12.6852 78.7686 12.9131C78.57 13.141 78.443 13.4583 78.3877 13.8652H80.6484V13.7773C80.6224 13.3802 80.5166 13.0807 80.3311 12.8789C80.1455 12.6738 79.8883 12.5713 79.5596 12.5713ZM87.3721 14.4121C87.3721 15.2292 87.1865 15.8818 86.8154 16.3701C86.4443 16.8551 85.9463 17.0977 85.3213 17.0977C84.7419 17.0977 84.278 16.9072 83.9297 16.5264V19.0312H82.7432V11.7168H83.8369L83.8857 12.2539C84.234 11.8307 84.7077 11.6191 85.3066 11.6191C85.9512 11.6191 86.4557 11.86 86.8203 12.3418C87.1882 12.8203 87.3721 13.486 87.3721 14.3389V14.4121ZM86.1904 14.3096C86.1904 13.7822 86.0846 13.3639 85.873 13.0547C85.6647 12.7454 85.3652 12.5908 84.9746 12.5908C84.4896 12.5908 84.1413 12.791 83.9297 13.1914V15.5352C84.1445 15.9453 84.4961 16.1504 84.9844 16.1504C85.362 16.1504 85.6566 15.999 85.8682 15.6963C86.083 15.3903 86.1904 14.9281 86.1904 14.3096ZM91.5371 17C91.485 16.8991 91.4395 16.7347 91.4004 16.5068C91.0228 16.9007 90.5605 17.0977 90.0137 17.0977C89.4831 17.0977 89.0501 16.9463 88.7148 16.6436C88.3796 16.3408 88.2119 15.9665 88.2119 15.5205C88.2119 14.9574 88.4202 14.526 88.8369 14.2266C89.2568 13.9238 89.8558 13.7725 90.6338 13.7725H91.3613V13.4258C91.3613 13.1523 91.2848 12.9342 91.1318 12.7715C90.9788 12.6055 90.7461 12.5225 90.4336 12.5225C90.1634 12.5225 89.9421 12.5908 89.7695 12.7275C89.597 12.861 89.5107 13.0319 89.5107 13.2402H88.3242C88.3242 12.9505 88.4202 12.6803 88.6123 12.4297C88.8044 12.1758 89.0648 11.9772 89.3936 11.834C89.7256 11.6908 90.0951 11.6191 90.502 11.6191C91.1204 11.6191 91.6136 11.7754 91.9814 12.0879C92.3493 12.3971 92.5381 12.8333 92.5479 13.3965V15.7793C92.5479 16.2546 92.6146 16.6338 92.748 16.917V17H91.5371ZM90.2334 16.1455C90.4678 16.1455 90.6875 16.0885 90.8926 15.9746C91.1009 15.8607 91.2572 15.7077 91.3613 15.5156V14.5195H90.7217C90.2822 14.5195 89.9518 14.596 89.7305 14.749C89.5091 14.902 89.3984 15.1185 89.3984 15.3984C89.3984 15.6263 89.4733 15.8086 89.623 15.9453C89.776 16.0788 89.9795 16.1455 90.2334 16.1455ZM95.5605 15.3008L96.6348 11.7168H97.8994L95.7998 17.8008C95.4775 18.6895 94.9307 19.1338 94.1592 19.1338C93.9867 19.1338 93.7962 19.1045 93.5879 19.0459V18.1279L93.8125 18.1426C94.112 18.1426 94.3366 18.0872 94.4863 17.9766C94.6393 17.8691 94.7598 17.6868 94.8477 17.4297L95.0186 16.9756L93.1631 11.7168H94.4424L95.5605 15.3008ZM99.7012 11.7168L99.7354 12.2686C100.106 11.8356 100.614 11.6191 101.259 11.6191C101.965 11.6191 102.449 11.8893 102.709 12.4297C103.093 11.8893 103.633 11.6191 104.33 11.6191C104.913 11.6191 105.346 11.7803 105.629 12.1025C105.915 12.4248 106.062 12.9001 106.068 13.5283V17H104.882V13.5625C104.882 13.2272 104.809 12.9814 104.662 12.8252C104.516 12.6689 104.273 12.5908 103.935 12.5908C103.664 12.5908 103.443 12.6641 103.271 12.8105C103.101 12.9538 102.982 13.1426 102.914 13.377L102.919 17H101.732V13.5234C101.716 12.9017 101.399 12.5908 100.78 12.5908C100.305 12.5908 99.9681 12.7845 99.7695 13.1719V17H98.583V11.7168H99.7012ZM109.613 17.0977C108.861 17.0977 108.251 16.8617 107.782 16.3896C107.317 15.9144 107.084 15.2829 107.084 14.4951V14.3486C107.084 13.8213 107.185 13.3509 107.387 12.9375C107.592 12.5208 107.878 12.1969 108.246 11.9658C108.614 11.7347 109.024 11.6191 109.477 11.6191C110.196 11.6191 110.751 11.8486 111.142 12.3076C111.535 12.7666 111.732 13.416 111.732 14.2559V14.7344H108.28C108.316 15.1706 108.461 15.5156 108.715 15.7695C108.972 16.0234 109.294 16.1504 109.682 16.1504C110.225 16.1504 110.668 15.9307 111.01 15.4912L111.649 16.1016C111.438 16.4173 111.155 16.6631 110.8 16.8389C110.448 17.0114 110.053 17.0977 109.613 17.0977ZM109.472 12.5713C109.146 12.5713 108.882 12.6852 108.681 12.9131C108.482 13.141 108.355 13.4583 108.3 13.8652H110.561V13.7773C110.535 13.3802 110.429 13.0807 110.243 12.8789C110.058 12.6738 109.8 12.5713 109.472 12.5713ZM113.759 11.7168L113.793 12.3271C114.184 11.8551 114.696 11.6191 115.331 11.6191C116.431 11.6191 116.991 12.249 117.011 13.5088V17H115.824V13.5771C115.824 13.2419 115.751 12.9945 115.604 12.835C115.461 12.6722 115.225 12.5908 114.896 12.5908C114.418 12.5908 114.062 12.8073 113.827 13.2402V17H112.641V11.7168H113.759ZM119.711 10.4326V11.7168H120.644V12.5957H119.711V15.5449C119.711 15.7467 119.75 15.8932 119.828 15.9844C119.91 16.0723 120.053 16.1162 120.258 16.1162C120.395 16.1162 120.533 16.0999 120.673 16.0674V16.9854C120.403 17.0602 120.142 17.0977 119.892 17.0977C118.98 17.0977 118.524 16.5947 118.524 15.5889V12.5957H117.655V11.7168H118.524V10.4326H119.711ZM124.516 15.5645C124.516 15.3529 124.428 15.1917 124.252 15.0811C124.079 14.9704 123.791 14.8727 123.388 14.7881C122.984 14.7035 122.647 14.596 122.377 14.4658C121.785 14.1794 121.488 13.7643 121.488 13.2207C121.488 12.765 121.68 12.3841 122.064 12.0781C122.449 11.7721 122.937 11.6191 123.529 11.6191C124.161 11.6191 124.67 11.7754 125.058 12.0879C125.448 12.4004 125.644 12.8057 125.644 13.3037H124.457C124.457 13.0758 124.372 12.887 124.203 12.7373C124.034 12.5843 123.809 12.5078 123.529 12.5078C123.269 12.5078 123.056 12.568 122.89 12.6885C122.727 12.8089 122.646 12.9701 122.646 13.1719C122.646 13.3542 122.722 13.4958 122.875 13.5967C123.028 13.6976 123.337 13.8001 123.803 13.9043C124.268 14.0052 124.633 14.1273 124.896 14.2705C125.163 14.4105 125.36 14.5798 125.487 14.7783C125.618 14.9769 125.683 15.2178 125.683 15.501C125.683 15.9762 125.486 16.362 125.092 16.6582C124.698 16.9512 124.182 17.0977 123.544 17.0977C123.111 17.0977 122.725 17.0195 122.387 16.8633C122.048 16.707 121.785 16.4922 121.596 16.2188C121.407 15.9453 121.312 15.6507 121.312 15.335H122.465C122.481 15.6149 122.587 15.8314 122.782 15.9844C122.978 16.1341 123.236 16.209 123.559 16.209C123.871 16.209 124.109 16.1504 124.271 16.0332C124.434 15.9128 124.516 15.7565 124.516 15.5645Z"
        fill="#EF404A"
      />
    </svg>
  )
}

const CloseIcon = ({ sizeInPx, active }) => {
  return (
    <svg
      width={`${sizeInPx ? sizeInPx : 32}`}
      height={`${sizeInPx ? sizeInPx : 32}`}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 7L7 25"
        stroke={active ? 'grey' : 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 25L7 7"
        stroke={active ? 'grey' : 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const CircleTick = ({ active, sizeInPx, color, bcolor }) => {
  return !active ? (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        fill="#549EE8"
        stroke="#6AACEC"
        strokeWidth="1.1875"
        strokeMiterlimit="10"
      />
      <path
        d="M11.667 21C16.6376 21 20.667 16.9706 20.667 12C20.667 7.02944 16.6376 3 11.667 3C6.69643 3 2.66699 7.02944 2.66699 12C2.66699 16.9706 6.69643 21 11.667 21Z"
        fill="white"
        stroke="#6AACEC"
        strokeWidth="1.1875"
        strokeMiterlimit="10"
      />
    </svg>
  ) : (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        fill="#549EE8"
        stroke="#6AACEC"
        strokeWidth="1.1875"
        strokeMiterlimit="10"
      />
      <path
        d="M16.375 8.93799L10.5417 15.063L7.625 12.0006"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const CircleTick2 = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 22.75C18.3848 22.75 22.75 18.3848 22.75 13C22.75 7.61522 18.3848 3.25 13 3.25C7.61522 3.25 3.25 7.61522 3.25 13C3.25 18.3848 7.61522 22.75 13 22.75Z"
        stroke="#388E3C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4688 10.5625L11.5104 16.25L8.53125 13.4062"
        stroke="#388E3C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const SqureClickBox = ({ active }) => {
  return active ? (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2308 6.09277L7.00335 9.17352L5.38965 7.63315"
        stroke="black"
        strokeWidth="0.880213"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.211 2.57227H3.40886C3.16579 2.57227 2.96875 2.76931 2.96875 3.01237V11.8145C2.96875 12.0576 3.16579 12.2546 3.40886 12.2546H12.211C12.454 12.2546 12.6511 12.0576 12.6511 11.8145V3.01237C12.6511 2.76931 12.454 2.57227 12.211 2.57227Z"
        stroke="black"
        strokeWidth="0.880213"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.57066 5.65283L6.0498 9.17368" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.57066 9.17368L6.0498 5.65283" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.211 2.57227H3.40886C3.16579 2.57227 2.96875 2.76931 2.96875 3.01237V11.8145C2.96875 12.0576 3.16579 12.2546 3.40886 12.2546H12.211C12.454 12.2546 12.6511 12.0576 12.6511 11.8145V3.01237C12.6511 2.76931 12.454 2.57227 12.211 2.57227Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const UploadIcon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.375 5.62305L8 2.99805L10.625 5.62305"
        stroke="#EFEFEF"
        strokeWidth="1.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.375 5.62305L8 2.99805L10.625 5.62305"
        stroke="white"
        strokeWidth="1.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 10V3" stroke="#EFEFEF" strokeWidth="1.1875" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 10V3" stroke="white" strokeWidth="1.1875" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14 9V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H2.5C2.36739 14 2.24021 13.9473 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5V9"
        stroke="white"
        strokeWidth="1.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const DocumentIcon = () => {
  return (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.2998 7.5H10.4998"
        stroke="#549EE8"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.2998 10H10.4998"
        stroke="#549EE8"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.2998 12.5H8.3998"
        stroke="#838F9D"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2825 16.875H3.15C3.01076 16.875 2.87723 16.8092 2.77877 16.6919C2.68031 16.5747 2.625 16.4158 2.625 16.25V3.75C2.625 3.58424 2.68031 3.42527 2.77877 3.30806C2.87723 3.19085 3.01076 3.125 3.15 3.125H13.65C13.7892 3.125 13.9228 3.19085 14.0212 3.30806C14.1197 3.42527 14.175 3.58424 14.175 3.75V12.2411C14.175 12.3232 14.1614 12.4045 14.135 12.4803C14.1087 12.5561 14.07 12.625 14.0212 12.6831L10.6538 16.6919C10.605 16.75 10.5471 16.796 10.4834 16.8274C10.4198 16.8588 10.3515 16.875 10.2825 16.875V16.875Z"
        stroke="#838F9D"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1275 12.499H10.5V16.8178"
        stroke="#838F9D"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// const TimerIcon3 = ({ sizeInPx, color, bcolor }) => {
//   // const size = sizeInPx ? sizeInPx : 56
//   // const mColor = color ? color : '#1FA7CD'

//   return (
//     <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <g filter="url(#filter0_dd_2_23423)">
//         <path
//           d="M3 10C3 5.58172 6.58172 2 11 2H35C39.4183 2 43 5.58172 43 10V34C43 38.4183 39.4183 42 35 42H11C6.58172 42 3 38.4183 3 34V10Z"
//           fill="#EFEFEF"
//         />
//         <path
//           d="M3 10C3 5.58172 6.58172 2 11 2H35C39.4183 2 43 5.58172 43 10V34C43 38.4183 39.4183 42 35 42H11C6.58172 42 3 38.4183 3 34V10Z"
//           fill="#1FA7CD"
//         />
//         <path
//           d="M23 28.875C26.797 28.875 29.875 25.797 29.875 22C29.875 18.203 26.797 15.125 23 15.125C19.203 15.125 16.125 18.203 16.125 22C16.125 25.797 19.203 28.875 23 28.875Z"
//           stroke="white"
//           strokeWidth="1.6"
//           strokeMiterlimit="10"
//         />
//         <path
//           d="M23 21.9998L26.0936 18.9062"
//           stroke="white"
//           strokeWidth="1.6"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//         <path
//           d="M21.125 12.625H24.875"
//           stroke="white"
//           strokeWidth="1.6"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </g>
//       <defs>
//         <filter
//           id="filter0_dd_2_23423"
//           x="0"
//           y="0"
//           width="46"
//           height="46"
//           filterUnits="userSpaceOnUse"
//           colorInterpolationFilters="sRGB"
//         >
//           <feFlood flood-opacity="0" result="BackgroundImageFix" />
//           <feColorMatrix
//             in="SourceAlpha"
//             type="matrix"
//             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//             result="hardAlpha"
//           />
//           <feOffset dy="1" />
//           <feGaussianBlur stdDeviation="1" />
//           <feColorMatrix
//             type="matrix"
//             values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
//           />
//           <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_23423" />
//           <feColorMatrix
//             in="SourceAlpha"
//             type="matrix"
//             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//             result="hardAlpha"
//           />
//           <feOffset dy="1" />
//           <feGaussianBlur stdDeviation="1.5" />
//           <feColorMatrix
//             type="matrix"
//             values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
//           />
//           <feBlend mode="normal" in2="effect1_dropShadow_2_23423" result="effect2_dropShadow_2_23423" />
//           <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2_23423" result="shape" />
//         </filter>
//       </defs>
//     </svg>
//   )
// }

const ConsolidateIcon = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_2_24953)">
        <path
          d="M8 12C8 7.58172 11.5817 4 16 4H40C44.4183 4 48 7.58172 48 12V36C48 40.4183 44.4183 44 40 44H16C11.5817 44 8 40.4183 8 36V12Z"
          fill="#1FA7CD"
        />
        <path
          d="M20.5 18.375H35.5V29C35.5 29.1658 35.4341 29.3247 35.3169 29.4419C35.1997 29.5592 35.0407 29.625 34.875 29.625H21.125C20.9592 29.625 20.8003 29.5592 20.6831 29.4419C20.5658 29.3247 20.5 29.1658 20.5 29V18.375Z"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5 22.125H35.5"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5 25.875H35.5"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.875 22.125V29.625"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2_24953"
          x="0"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_24953" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_24953" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

const TimerIcon2 = () => {
  //  const offset = 56 / 4
  const InnerTmr = () => {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M10 17.875C13.797 17.875 16.875 14.797 16.875 11C16.875 7.20304 13.797 4.125 10 4.125C6.20304 4.125 3.125 7.20304 3.125 11C3.125 14.797 6.20304 17.875 10 17.875Z"
            stroke="white"
            strokeWidth="1.6"
            strokeMiterlimit="10"
          />
          <path
            d="M10 10.9998L13.0936 7.90625"
            stroke="white"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.125 1.625H11.875"
            stroke="white"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    )
  }
  return (
    <div className={cls.flexContainer}>
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_2_24953)">
          <path
            d="M8 12C8 7.58172 11.5817 4 16 4H40C44.4183 4 48 7.58172 48 12V36C48 40.4183 44.4183 44 40 44H16C11.5817 44 8 40.4183 8 36V12Z"
            fill="#1FA7CD"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_2_24953"
            x="0"
            y="0"
            width="56"
            height="56"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0 0.0877722 0 0 0 0.2 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_24953" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_24953" result="shape" />
          </filter>
        </defs>
      </svg>
      <div className={cls.absolute}>
        <InnerTmr />
      </div>
    </div>
  )
}

const SquareBadge = () => {
  return (
    <svg width="53" height="54" viewBox="0 0 53 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_37_39430)">
        <path
          d="M7.94141 12.0453C7.94141 7.91913 11.2863 4.57422 15.4125 4.57422H37.8257C41.9519 4.57422 45.2968 7.91913 45.2968 12.0453V34.4585C45.2968 38.5847 41.9519 41.9296 37.8257 41.9296H15.4125C11.2863 41.9296 7.94141 38.5847 7.94141 34.4585V12.0453Z"
          fill="#FFEA79"
        />
        {/* <path
          d="M24.1079 14.8597L24.1079 21.5127L22.7946 21.5127L22.7946 16.3736L21.2169 16.8752V15.8401L23.9665 14.8597H24.1079ZM31.745 20.4867V21.5127L27.2032 21.5127V20.6372L29.351 18.3344C29.5668 18.0942 29.737 17.8829 29.8617 17.7006C29.9863 17.5151 30.076 17.3494 30.1307 17.2035C30.1885 17.0546 30.2174 16.9132 30.2174 16.7794C30.2174 16.5788 30.1839 16.407 30.117 16.2642C30.0502 16.1182 29.9514 16.0058 29.8206 15.9267C29.693 15.8477 29.5349 15.8082 29.3464 15.8082C29.1458 15.8082 28.9725 15.8568 28.8266 15.9541C28.6837 16.0514 28.5742 16.1866 28.4982 16.3599C28.4253 16.5332 28.3888 16.7293 28.3888 16.9482L27.071 16.9482C27.071 16.553 27.1652 16.1912 27.3537 15.8629C27.5422 15.5315 27.8082 15.2686 28.1517 15.074C28.4952 14.8764 28.9026 14.7776 29.3738 14.7776C29.8389 14.7776 30.231 14.8536 30.5502 15.0056C30.8725 15.1546 31.1157 15.3704 31.2798 15.6531C31.447 15.9328 31.5306 16.2672 31.5306 16.6563C31.5306 16.8752 31.4957 17.0895 31.4258 17.2993C31.3558 17.506 31.2555 17.7127 31.1248 17.9194C30.9971 18.1231 30.8421 18.3298 30.6597 18.5396C30.4773 18.7493 30.2751 18.9667 30.0532 19.1917L28.8995 20.4867L31.745 20.4867ZM20.3714 25.8734L20.3714 32.5127H19.0035L19.0035 25.8734L20.3714 25.8734ZM23.0162 28.7097V29.7767L19.9975 29.7767V28.7097L23.0162 28.7097ZM23.3354 25.8734L23.3354 26.945L19.9975 26.945L19.9975 25.8734L23.3354 25.8734ZM26.5174 25.8734L26.5174 32.5127H25.154L25.154 25.8734H26.5174ZM29.941 25.8734L31.1905 28.1898L32.4399 25.8734L34.004 25.8734L32.0751 29.1657L34.0541 32.5127H32.4764L31.1905 30.1506L29.9045 32.5127L28.3177 32.5127L30.3013 29.1657L28.3678 25.8734L29.941 25.8734Z"
          fill="#2E3238"
        /> */}
      </g>
      <defs>
        <filter
          id="filter0_d_37_39430"
          x="0.470332"
          y="0.838682"
          width="52.2986"
          height="52.2976"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.73554" />
          <feGaussianBlur stdDeviation="3.73554" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.854446 0 0 0 0 0.786138 0 0 0 0 0.418577 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_37_39430" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_37_39430" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

const RepaymentScheduleIcon = () => {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.33984 13.8843C2.33984 7.69511 7.35722 2.67773 13.5465 2.67773C19.7357 2.67773 24.7531 7.69511 24.7531 13.8843C24.7531 20.0736 19.7357 25.091 13.5465 25.091C7.35722 25.091 2.33984 20.0736 2.33984 13.8843Z"
        fill="#D1FADF"
      />
      <path
        d="M17.0487 10.0322H10.0445C9.85113 10.0322 9.69434 10.189 9.69434 10.3824V17.3866C9.69434 17.58 9.85113 17.7368 10.0445 17.7368H17.0487C17.2421 17.7368 17.3989 17.58 17.3989 17.3866V10.3824C17.3989 10.189 17.2421 10.0322 17.0487 10.0322Z"
        stroke="black"
        strokeWidth="0.933884"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6479 9.33203V10.7329"
        stroke="black"
        strokeWidth="0.933884"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4453 9.33203V10.7329"
        stroke="black"
        strokeWidth="0.933884"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.69434 12.1333H17.3989"
        stroke="black"
        strokeWidth="0.933884"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5465 23.2232C8.38876 23.2232 4.20761 19.042 4.20761 13.8843H0.472075C0.472075 21.1051 6.32568 26.9587 13.5465 26.9587V23.2232ZM22.8853 13.8843C22.8853 19.042 18.7042 23.2232 13.5465 23.2232V26.9587C20.7672 26.9587 26.6208 21.1051 26.6208 13.8843H22.8853ZM13.5465 4.5455C18.7042 4.5455 22.8853 8.72665 22.8853 13.8843H26.6208C26.6208 6.66357 20.7672 0.809966 13.5465 0.809966V4.5455ZM13.5465 0.809966C6.32568 0.809966 0.472075 6.66357 0.472075 13.8843H4.20761C4.20761 8.72665 8.38876 4.5455 13.5465 4.5455V0.809966Z"
        fill="#ECFDF3"
      />
    </svg>
  )
}

const CaretDownIcon = ({ active }) => {
  return !active ? (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8935 6.0166L8.22411 10.686L3.55469 6.0166"
        stroke="black"
        strokeWidth="1.24518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.55471 9.75195L8.22413 5.08253L12.8936 9.75195"
        stroke="black"
        strokeWidth="1.24518"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const DollarSign = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
        fill="#EFEFEF"
      />
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
        fill="white"
      />
      <path
        d="M20 11.875V13.75"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 26.25V28.125"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.375 16.875C24.375 16.4646 24.2942 16.0583 24.1371 15.6791C23.9801 15.3 23.7499 14.9555 23.4597 14.6653C23.1695 14.3751 22.825 14.1449 22.4459 13.9879C22.0667 13.8308 21.6604 13.75 21.25 13.75H18.4375C17.6087 13.75 16.8138 14.0792 16.2278 14.6653C15.6417 15.2513 15.3125 16.0462 15.3125 16.875C15.3125 17.7038 15.6417 18.4987 16.2278 19.0847C16.8138 19.6708 17.6087 20 18.4375 20H21.875C22.7038 20 23.4987 20.3292 24.0847 20.9153C24.6708 21.5013 25 22.2962 25 23.125C25 23.9538 24.6708 24.7487 24.0847 25.3347C23.4987 25.9208 22.7038 26.25 21.875 26.25H18.125C17.2962 26.25 16.5013 25.9208 15.9153 25.3347C15.3292 24.7487 15 23.9538 15 23.125"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const MasterCard = () => {
  return (
    <svg width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white" stroke="#D9D9D9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 17.3295C15.9949 18.3275 14.459 18.93 12.7807 18.93C9.03582 18.93 6 15.9303 6 12.23C6 8.52972 9.03582 5.53003 12.7807 5.53003C14.459 5.53003 15.9949 6.13253 17.179 7.13057C18.363 6.13253 19.8989 5.53003 21.5773 5.53003C25.3221 5.53003 28.358 8.52972 28.358 12.23C28.358 15.9303 25.3221 18.93 21.5773 18.93C19.8989 18.93 18.363 18.3275 17.179 17.3295Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 17.3295C18.6369 16.1006 19.5614 14.272 19.5614 12.23C19.5614 10.1881 18.6369 8.35947 17.179 7.13057C18.363 6.13253 19.8989 5.53003 21.5772 5.53003C25.3221 5.53003 28.3579 8.52972 28.3579 12.23C28.3579 15.9303 25.3221 18.93 21.5772 18.93C19.8989 18.93 18.363 18.3275 17.179 17.3295Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 17.3295C18.6369 16.1006 19.5614 14.272 19.5614 12.2301C19.5614 10.1881 18.6369 8.35952 17.179 7.13062C15.7211 8.35952 14.7966 10.1881 14.7966 12.2301C14.7966 14.272 15.7211 16.1006 17.179 17.3295Z"
        fill="#FF5E00"
      />
    </svg>
  )
}

const MasterCardL = () => {
  return (
    // <svg width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <svg width="51" height="37.5" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white" stroke="#D9D9D9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 17.3295C15.9949 18.3275 14.459 18.93 12.7807 18.93C9.03582 18.93 6 15.9303 6 12.23C6 8.52972 9.03582 5.53003 12.7807 5.53003C14.459 5.53003 15.9949 6.13253 17.179 7.13057C18.363 6.13253 19.8989 5.53003 21.5773 5.53003C25.3221 5.53003 28.358 8.52972 28.358 12.23C28.358 15.9303 25.3221 18.93 21.5773 18.93C19.8989 18.93 18.363 18.3275 17.179 17.3295Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 17.3295C18.6369 16.1006 19.5614 14.272 19.5614 12.23C19.5614 10.1881 18.6369 8.35947 17.179 7.13057C18.363 6.13253 19.8989 5.53003 21.5772 5.53003C25.3221 5.53003 28.3579 8.52972 28.3579 12.23C28.3579 15.9303 25.3221 18.93 21.5772 18.93C19.8989 18.93 18.363 18.3275 17.179 17.3295Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.179 17.3295C18.6369 16.1006 19.5614 14.272 19.5614 12.2301C19.5614 10.1881 18.6369 8.35952 17.179 7.13062C15.7211 8.35952 14.7966 10.1881 14.7966 12.2301C14.7966 14.272 15.7211 16.1006 17.179 17.3295Z"
        fill="#FF5E00"
      />
    </svg>
  )
}

const Visa = () => {
  return (
    <svg width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white" stroke="#D9D9D9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7503 16.3583H8.69056L7.146 10.2925C7.07269 10.0134 6.91703 9.76676 6.68806 9.6505C6.11664 9.35833 5.48696 9.1258 4.80005 9.00853V8.77499H8.11813C8.57607 8.77499 8.91953 9.1258 8.97677 9.53323L9.77817 13.9087L11.8369 8.77499H13.8394L10.7503 16.3583ZM14.9843 16.3583H13.039L14.6408 8.77499H16.5861L14.9843 16.3583ZM19.1028 10.8758C19.16 10.4674 19.5035 10.2338 19.9042 10.2338C20.5338 10.1752 21.2197 10.2925 21.7922 10.5836L22.1356 8.95091C21.5632 8.71737 20.9335 8.6001 20.3621 8.6001C18.4741 8.6001 17.1003 9.6505 17.1003 11.1083C17.1003 12.2174 18.0734 12.7997 18.7603 13.1505C19.5035 13.5003 19.7897 13.7338 19.7324 14.0836C19.7324 14.6083 19.16 14.8419 18.5886 14.8419C17.9017 14.8419 17.2147 14.667 16.5861 14.3748L16.2426 16.0086C16.9295 16.2997 17.6727 16.417 18.3596 16.417C20.4766 16.4746 21.7922 15.4252 21.7922 13.8501C21.7922 11.8666 19.1028 11.7503 19.1028 10.8758ZM28.6 16.3583L27.0555 8.77499H25.3965C25.053 8.77499 24.7095 9.00853 24.5951 9.35833L21.7349 16.3583H23.7374L24.1371 15.2503H26.5976L26.8265 16.3583H28.6ZM25.6827 10.8172L26.2541 13.6752H24.6523L25.6827 10.8172Z"
        fill="#172B85"
      />
    </svg>
  )
}

const VisaL = () => {
  return (
    <svg width="51" height="37.5" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white" stroke="#D9D9D9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7503 16.3583H8.69056L7.146 10.2925C7.07269 10.0134 6.91703 9.76676 6.68806 9.6505C6.11664 9.35833 5.48696 9.1258 4.80005 9.00853V8.77499H8.11813C8.57607 8.77499 8.91953 9.1258 8.97677 9.53323L9.77817 13.9087L11.8369 8.77499H13.8394L10.7503 16.3583ZM14.9843 16.3583H13.039L14.6408 8.77499H16.5861L14.9843 16.3583ZM19.1028 10.8758C19.16 10.4674 19.5035 10.2338 19.9042 10.2338C20.5338 10.1752 21.2197 10.2925 21.7922 10.5836L22.1356 8.95091C21.5632 8.71737 20.9335 8.6001 20.3621 8.6001C18.4741 8.6001 17.1003 9.6505 17.1003 11.1083C17.1003 12.2174 18.0734 12.7997 18.7603 13.1505C19.5035 13.5003 19.7897 13.7338 19.7324 14.0836C19.7324 14.6083 19.16 14.8419 18.5886 14.8419C17.9017 14.8419 17.2147 14.667 16.5861 14.3748L16.2426 16.0086C16.9295 16.2997 17.6727 16.417 18.3596 16.417C20.4766 16.4746 21.7922 15.4252 21.7922 13.8501C21.7922 11.8666 19.1028 11.7503 19.1028 10.8758ZM28.6 16.3583L27.0555 8.77499H25.3965C25.053 8.77499 24.7095 9.00853 24.5951 9.35833L21.7349 16.3583H23.7374L24.1371 15.2503H26.5976L26.8265 16.3583H28.6ZM25.6827 10.8172L26.2541 13.6752H24.6523L25.6827 10.8172Z"
        fill="#172B85"
      />
    </svg>
  )
}

const AECard = () => {
  return (
    <svg width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="34" height="24" rx="4" fill="#1F72CD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.09542 9L2.91431 16.2467H6.72254L7.19465 15.0913H8.27379L8.7459 16.2467H12.9377V15.3649L13.3112 16.2467H15.4795L15.8531 15.3462V16.2467H24.5709L25.6309 15.1213L26.6235 16.2467L31.1011 16.2561L27.91 12.6436L31.1011 9H26.6929L25.661 10.1046L24.6997 9H15.2159L14.4015 10.8704L13.568 9H9.76774V9.85186L9.34498 9H6.09542ZM6.83229 10.029H8.6886L10.7986 14.9431V10.029H12.8322L14.4619 13.5524L15.9639 10.029H17.9873V15.2291H16.7561L16.746 11.1544L14.9511 15.2291H13.8498L12.0448 11.1544V15.2291H9.51203L9.03187 14.0633H6.43769L5.95851 15.228H4.60147L6.83229 10.029ZM24.1198 10.029H19.1137V15.226H24.0423L25.6309 13.5036L27.1621 15.226H28.7627L26.4362 12.6426L28.7627 10.029H27.2315L25.651 11.7316L24.1198 10.029ZM7.73532 10.9089L6.88064 12.9856H8.58901L7.73532 10.9089ZM20.3499 12.055V11.1057V11.1048H23.4736L24.8366 12.6229L23.4132 14.1493H20.3499V13.113H23.081V12.055H20.3499Z"
        fill="white"
      />
    </svg>
  )
}

const SelectTick = ({ active, color }) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5484 6.35159C20.7734 6.57662 20.8997 6.88179 20.8997 7.19999C20.8997 7.51818 20.7734 7.82335 20.5484 8.04839L10.9484 17.6484C10.7234 17.8734 10.4182 17.9997 10.1 17.9997C9.7818 17.9997 9.47663 17.8734 9.2516 17.6484L4.4516 12.8484C4.23301 12.6221 4.11206 12.3189 4.11479 12.0043C4.11753 11.6897 4.24373 11.3887 4.46622 11.1662C4.68871 10.9437 4.98968 10.8175 5.30432 10.8148C5.61895 10.812 5.92208 10.933 6.1484 11.1516L10.1 15.1032L18.8516 6.35159C19.0766 6.12662 19.3818 6.00024 19.7 6.00024C20.0182 6.00024 20.3234 6.12662 20.5484 6.35159Z"
        fill={color ? color : active ? '#273869' : '#E2E2E2'}
      />
    </svg>
  )
}

const AlertIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99983 6.66667V10M9.99983 13.3333H10.0082M8.57483 2.38334L1.5165 14.1667C1.37097 14.4187 1.29397 14.7044 1.29316 14.9954C1.29234 15.2865 1.36774 15.5726 1.51186 15.8254C1.65597 16.0783 1.86377 16.289 2.11459 16.4366C2.36541 16.5841 2.6505 16.6635 2.9415 16.6667H17.0582C17.3492 16.6635 17.6343 16.5841 17.8851 16.4366C18.1359 16.289 18.3437 16.0783 18.4878 15.8254C18.6319 15.5726 18.7073 15.2865 18.7065 14.9954C18.7057 14.7044 18.6287 14.4187 18.4832 14.1667L11.4248 2.38334C11.2763 2.13843 11.0671 1.93594 10.8175 1.79541C10.5679 1.65488 10.2863 1.58105 9.99983 1.58105C9.71339 1.58105 9.43178 1.65488 9.18217 1.79541C8.93257 1.93594 8.72339 2.13843 8.57483 2.38334Z"
        stroke="#DC6803"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const RequestSuccessTick = () => {
  return (
    <svg width="77" height="77" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M72.4286 38.5C72.4286 43.0142 71.551 47.4842 69.8459 51.6547C68.1408 55.8253 65.6417 59.6148 62.4911 62.8068C59.3405 65.9988 55.6003 68.5309 51.4839 70.2584C47.3675 71.9859 42.9555 72.875 38.5 72.875C34.0444 72.875 29.6325 71.9859 25.5161 70.2584C21.3997 68.5308 17.6594 65.9988 14.5089 62.8068C11.3583 59.6148 8.85914 55.8253 7.15407 51.6547C5.449 47.4842 4.57141 43.0142 4.57141 38.5C4.57141 33.9858 5.449 29.5158 7.15407 25.3452C8.85915 21.1747 11.3583 17.3852 14.5089 14.1932C17.6594 11.0012 21.3997 8.46914 25.5161 6.74164C29.6325 5.01413 34.0444 4.125 38.5 4.125C42.9556 4.125 47.3675 5.01414 51.4839 6.74165C55.6003 8.46916 59.3406 11.0012 62.4911 14.1932C65.6417 17.3852 68.1408 21.1747 69.8459 25.3453C71.551 29.5158 72.4286 33.9858 72.4286 38.5L72.4286 38.5Z"
        stroke="white"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.821 61.1875C50.1883 61.1875 60.2139 51.03 60.2139 38.5C60.2139 25.97 50.1883 15.8125 37.821 15.8125C25.4538 15.8125 15.4282 25.97 15.4282 38.5C15.4282 51.03 25.4538 61.1875 37.821 61.1875Z"
        stroke="#00BBB6"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.0844 32.8281L34.3998 46.0625L27.5576 39.4453"
        stroke="#00BBB6"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const ConfirmIcon = () => {
  const [color, setColor] = useState('#273869')

  return (
    <svg
      onMouseOver={() => {
        setColor('rgba(39, 56, 105, 0.5)')
      }}
      onMouseLeave={() => {
        setColor('rgba(39, 56, 105, 1)')
      }}
      width="27"
      height="27"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 13L14.1666 20L10.5 16.5"
        stroke={color} //"black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const CancelIcon = () => {
  const [color, setColor] = useState('#273869')
  return (
    <svg
      onMouseOver={() => {
        setColor('rgba(39, 56, 105, 0.5)')
      }}
      onMouseLeave={() => {
        setColor('rgba(39, 56, 105, 1)')
      }}
      width="27"
      height="27"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 12L12 20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 20L12 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const PencilIcon = () => {
  const [color, setColor] = useState('#273869')

  return (
    <svg
      style={{ cursor: 'pointer' }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseOver={() => {
        setColor('rgba(39, 56, 105, 0.5)')
      }}
      onMouseLeave={() => {
        setColor('rgba(39, 56, 105, 1)')
      }}
    >
      <path
        d="M7.625 16.5314H4.0625C3.90503 16.5314 3.75401 16.4688 3.64266 16.3575C3.53131 16.2462 3.46875 16.0951 3.46875 15.9377V12.6211C3.46875 12.5431 3.48411 12.4659 3.51395 12.3939C3.54379 12.3218 3.58752 12.2564 3.64266 12.2012L12.5489 3.295C12.6603 3.18365 12.8113 3.12109 12.9688 3.12109C13.1262 3.12109 13.2772 3.18365 13.3886 3.295L16.7052 6.61156C16.8165 6.72291 16.8791 6.87393 16.8791 7.0314C16.8791 7.18888 16.8165 7.3399 16.7052 7.45125L7.625 16.5314Z"
        stroke={color}
        strokeWidth="1.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5938 5.25L14.75 9.40625"
        stroke={color}
        strokeWidth="1.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const Note = () => {
  return (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.3 7.5H10.5"
        stroke="#549EE8"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3 10H10.5"
        stroke="#549EE8"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3 12.5H8.4"
        stroke="#838F9D"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2825 16.875H3.15C3.01076 16.875 2.87723 16.8092 2.77877 16.6919C2.68031 16.5747 2.625 16.4158 2.625 16.25V3.75C2.625 3.58424 2.68031 3.42527 2.77877 3.30806C2.87723 3.19085 3.01076 3.125 3.15 3.125H13.65C13.7892 3.125 13.9228 3.19085 14.0212 3.30806C14.1197 3.42527 14.175 3.58424 14.175 3.75V12.2411C14.175 12.3232 14.1614 12.4045 14.135 12.4803C14.1087 12.5561 14.07 12.625 14.0212 12.6831L10.6538 16.6919C10.605 16.75 10.5471 16.796 10.4834 16.8274C10.4198 16.8588 10.3515 16.875 10.2825 16.875V16.875Z"
        stroke="#838F9D"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1275 12.4995H10.5V16.8183"
        stroke="#838F9D"
        strokeWidth="0.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const CrossCancelIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21.5C16.9706 21.5 21 17.4706 21 12.5C21 7.52944 16.9706 3.5 12 3.5C7.02944 3.5 3 7.52944 3 12.5C3 17.4706 7.02944 21.5 12 21.5Z"
        stroke="black"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M15 9.5L9 15.5"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 15.5L9 9.5"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const PropellCenter = ({ children, w, h }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: w ? `${w}px` : '16px',
        height: h ? `${h}px` : '16px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        <div>{children}</div>
      </div>
    </div>
  )
}

const PropellIconDown = ({ color }) => {
  const mColor = color ? color : '#292826'
  return (
    <PropellCenter>
      <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.27881 1L5.25257 5L1.22633 1"
          stroke={mColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </PropellCenter>
  )
}

const PropellIconUp = ({ color }) => {
  const mColor = color ? color : '#292826'
  return (
    <PropellCenter>
      <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.15137 5.64709L5.1776 1.4118L9.20384 5.64709"
          stroke={mColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </PropellCenter>
  )
}

const PropellRepeat = () => {
  return (
    <IconContext.Provider value={{ color: '#7bdfdd', size: 18 }}>
      <BsArrowRepeat />
    </IconContext.Provider>
  )
}

const PropellHelp = ({ sizeInPx, color }) => {
  const size = sizeInPx ? sizeInPx : 18
  const mColor = color ? color : 'white'
  return (
    <IconContext.Provider value={{ color: mColor, size: size }}>
      <BiHelpCircle />
    </IconContext.Provider>
  )
}

const PropellEmail = () => {
  return (
    <IconContext.Provider value={{ color: '#1b75bc', size: 20 }}>
      <FaRegEnvelope />
    </IconContext.Provider>
  )
}

const PropellPhone = () => {
  return (
    <IconContext.Provider value={{ color: '#1b75bc', size: 20 }}>
      <FaPhoneAlt />
    </IconContext.Provider>
  )
}

const GotoBtn = ({ color }) => {
  const mColor = color ? color : '#292826'
  return (
    <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 16H27" stroke={mColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18 7L27 16L18 25"
        stroke={mColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// const PropellCustomer = () => {
//   return (
//     <IconContext.Provider value={{ color: '#606D7B', size: 20 }}>
//       <RiCustomerService2Line />
//     </IconContext.Provider>
//   )
// }

const PropellTrade = () => {
  return (
    <IconContext.Provider value={{ color: '#606D7B', size: 20 }}>
      <MdOutlinePayments />
    </IconContext.Provider>
  )
}

const IconsPropell = ({ name, active, sizeInPx, color, bcolor }) => {
  switch (name) {
    case 'Support':
      return <Support active={active} />
    case 'Merchants':
      return <PropellTrade active={active} />
    case 'LendingTrade':
      return <Lending active={active} />
    case 'Payments':
      return <Payments active={active} />
    case 'Lending':
      return <Lending active={active} />
    case 'Lending2':
      return <Lending2 color={color} />
    case 'Accounts':
      return <Accounts active={active} />
    case 'Insights':
      return <Insights active={active} />
    case 'Lock':
      return <LockIcon active={active} />
    case 'Pending':
      return <PendingIcon active={active} />
    case 'PendingLg':
      return <PendingIconLg active={active} />
    case 'Money':
      return <MoneyIcon127x170 />
    case 'MoneySm':
      return <MoneyIcon80x107 />
    case 'MoneyIcon':
      return <MoneyIcon sizeInPx={sizeInPx} color={color} bcolor={bcolor} />
    case 'CreditCardIcon':
      return <CreditCardIcon sizeInPx={sizeInPx} color={color} bcolor={bcolor} />
    case 'InstituitionIcon':
      return <InstituitionIcon sizeInPx={sizeInPx} color={color} bcolor={bcolor} />
    case 'CircleArrowRight':
      return <CircleArrowRight sizeInPx={sizeInPx} color={color} bcolor={bcolor} />
    case 'CrossCancelIcon':
      return <CrossCancelIcon />
    case 'Loc':
      return <LOC />
    case 'LoanIcon':
      return <LoanIcon sizeInPx={sizeInPx} color={color} />
    case 'TimerIcon':
      return <TimerIcon sizeInPx={sizeInPx} color={color} bcolor={bcolor} />
    case 'TimerIcon2':
      return <TimerIcon2 sizeInPx={sizeInPx} color={color} bcolor={bcolor} />
    case 'TimerIcon3':
      return <Timer3 />
    case 'PencilSimple':
      return <PencilSimple />
    case 'InfoIconBtn':
      return <InfoIconBtn />
    case 'PropellCard1':
      return <PropellCard1 />
    case 'ArrowLeft':
      return <ArrowLeft sizeInPx={sizeInPx} color={color} />
    case 'ArrowRight':
      return <ArrowRight sizeInPx={sizeInPx} color={color} />
    case 'ArrowRight2':
      return <ArrowRight2 sizeInPx={sizeInPx} color={color} />
    case 'PropellHourGlass':
      return <PropellHourGlass />
    case 'PropellOverDue':
      return <PropellOverDue />
    case 'PropellOverDueRepayment':
      return <PropellOverDueRepayment />
    case 'ChevronLeftBtn':
      return <ChevronLeftBtn />
    case 'ChevronRightBtn':
      return <ChevronRightBtn />
    case 'CloseBtn':
      return <CloseIcon sizeInPx={sizeInPx} active={active} />
    case 'CircleTick':
      return <CircleTick sizeInPx={sizeInPx} active={active} />
    case 'CircleTick2':
      return <CircleTick2 />
    case 'UploadIcon':
      return <UploadIcon />
    case 'DocumentIcon':
      return <DocumentIcon />
    case 'ConsolidateIcon':
      return <ConsolidateIcon />
    case 'SqureClickBox':
      return <SqureClickBox active={active} />
    case 'SquareBadge':
      return <SquareBadge />
    case 'RepaymentScheduleIcon':
      return <RepaymentScheduleIcon />
    case 'CaretDownIcon':
      return <CaretDownIcon active={active} />
    case 'DollarSign':
      return <DollarSign />
    case 'MasterCard':
      return <MasterCard />
    case 'Visa':
      return <Visa />
    case 'MasterCardL':
      return <MasterCardL />
    case 'VisaL':
      return <VisaL />
    case 'AECard':
      return <AECard />
    case 'SelectTick':
      return <SelectTick active={active} color={color} />
    case 'AlertIcon':
      return <AlertIcon />
    case 'RequestSuccessTick':
      return <RequestSuccessTick />
    case 'ConfirmIcon':
      return <ConfirmIcon />
    case 'CancelIcon':
      return <CancelIcon />
    case 'PencilIcon':
      return <PencilIcon />
    case 'Note':
      return <Note />
    case 'PropellIconDown':
      return <PropellIconDown color={color} />
    case 'PropellIconUp':
      return <PropellIconUp color={color} />
    case 'FiArrowLeft':
      return <FiArrowLeft />
    case 'FiArrowRight':
      return <FiArrowRight />
    case 'Repeat':
      return <PropellRepeat />
    case 'GotoBtn':
      return <GotoBtn color={color} />
    case 'PropellHelp':
      return <PropellHelp sizeInPx={sizeInPx} color={color} />
    case 'PropellEmail':
      return <PropellEmail />
    case 'PropellPhone':
      return <PropellPhone />
    default:
      return null
  }
}

export default IconsPropell
